const resources = {
  en: {
    translation: {
      nav: {
        one: "One",
        Home: "Home",
        Language: "EN",
        English: "English",
        French: "Français",
        German: "Deutsch",
        Portugese: "Português",
        Spanish: "Español",
        Japanese: "日本語",
        Hindi: "हिंदी",
        Russian: "Русский",

        courses: "Courses",
      },

      general: {
        add: "Add",
        close: "Close",
        cancel: "Cancel",
      },

      sideMenu: {
        dashboard: "Dashboard",
        courses: "Courses",
        createCourse: "Create Course",
        shopCourses: "Shop Courses",
        myWishlist: "My Wishlist",
        webinars: "Webinar",
        results: "Results",
        notes: "Notes",
        forum: "Forum",
        grades: "Grades",
        achievements: "Achievements",
        announcements: "Announcements",
        accounts: "Accounts",
        allcategories:"AllCategories",
      },

      status: {
        ns: "Not Started",
        st: "Started",
        co: "Completed",
        caf: "Clear all filters",
        courseProgress: "Course Progress",
        filterStatus: "Filter by Status",
        addCourse: "Add a Course",
      },

      results: {
        resultReports: "Result Reports",
      },

      notes: {
        welcome2Notes:
          "Welcome to yslearn.com's intreractive to virtual notes feature",
        instructions: "Click on Add Notes to get started",
        addNote: "Add Note",
        deleteNote: "Delete Note",
        deleteConfMsg1: "Are you sure you want to delete this note?",
        deleteConfMsg2:
          "On confirmation, this note will be deleted permananently!",
        deleteConfBtn: "Confirm Delete",
      },

      404: {
        backToDash: "Back to Dashboard",
        oops: "Ooops the page you're looking for",
        doesNotExist: "does not exist",
      },

      profile: {
        profile: "Profile",
        moderation: "Moderation",
        payments: "Payments",

        firstName: "First Name",
        lastName: "Last Name",
        bio: "Bio",
        email: "Email",
        mobile: "Mobile",
        save: "Save",
        isAddressSame: "Is shipping address the same as the billing address?",
        address1: "Address Line 1",
        address2: "Address Line 2",
        cardHolderName: "Cardholder Name",
        cardNo: "Card Number",
        city: "City",
        stateProvince: "State or Province",
        expiry: "Expiry",
        postalZipCode: "Postal or Zip Code",
        cvv: "CVV",
        country: "Country",
      },

      tabs: {
        "Learn a new skill today": "Register for a course today!",
        forLiveCourses: "for LIVE online courses",
        chooseLiveWebinar:
          "Choose live webinar-based courses or self-study video-based courses.",
      },

      careers: {
        Careerswsmiklearn: "Careers with yslearn.com",
        curOppwEdu: "Current Open Opportunities with yslearn.com",
        ExpCareers:
          "Explore remote, flexible & exciting opportunities with yslearn.com, help us co-invent the LMS landscape for the future",
        ExpCurOpp: "Explore Open Positions",
      },

      instructorToolkit: {
        title:
          "The yslearn.com Instructor Toolkit: Your Design, Your Course, Your Pedagogy",
        description:
          "Have you created a self-study course? Do you live for live instruction? A mix of both? The yslearn.com platform is here to help you mix it up for all learning styles.",

        "Pre-Recorded Video": "Pre-Recorded Video",
        desc1:
          "Pre-recorded videos give students the flexibility they need to start, stop and replay as often as they need to process course material. Upload your existing MP4 video chapters for each section of your course.",
        "Live Webinars": "Live Webinars",
        desc2:
          "Sometimes, to understand the coordination of ideas, we need to see our instructors conduct demonstrations or interact in real time. Schedule synchronous learning opportunities using our webinar feature.",
        "Slide Shows": "Slide Shows",
        desc3:
          "Visual learners need accompanying images to support their understanding of new vocabulary terms. Share PowerPoint presentations to combine the two and communicate with structure and clarity.",
        "Quizzes & Exams": "Quizzes & Exams",
        desc4:
          "Compose multiple choice, reflective and descriptive questions to test the knowledge your students have acquired by taking your course. Set specific pass levels and use integrated marking tools to automate assessments.",
        "Articles and Resources": "Articles and Resources",
        desc5:
          "The depth and detail of articles and other text resources is unbeatable for linguistic learners. Post your e-books, pdfs, docs and other resources to the course page for easy reference and central storage.",
        "Distribute Certificates": "Distribute Certificates",
        desc6:
          "The reward for a job well done is a course certificate. Celebrate the skills your students have gained by taking your course and examination by issuing a custom electronic certificate of completion delivered via the yslearn.com platform.",
      },

      teacherIntro: {
        IntroTitle: "Become an Instructor with yslearn.com For FREE",
        IntroDesc1:
          "Do your learners thank you for your work? Are you always discovering new ways to express difficult concepts? Do you plan activities that apply knowledge to innovate and inspire? Do you know the satisfaction of helping students achieve their dreams?",
        IntroDesc2:
          "yslearn.in works with the best online instructors in the world. You might be one of them.",
        IntroDesc3:
          "Create a profile! Yes, we ask a lot of questions to make sure you are well-qualified, conscientious and safe. Show us your degrees, your portfolio and the relationships you’ve built through a clean social media reputation.",
        IntroDesc4:
          "Create a course using our drag and drop tool to upload your own educational materials. Sell your course to new and existing learners. Tag us in your social media posts and we’ll share what you have.",
        IntroDesc5:
          "yslearn.in helps you cultivate curiosity, inspiration and ambition. It’s what the best instructors do.",
      },

      teacherBenefits: {
        "You Teach, We Screen": "You Teach, We Screen",
        benefits1:
          "Whether you’re teaching beat box or physics, we verify your qualifications and experience. It protect ours students, your reputation and ours!",
        "Teach for Free": "Teach for Free",
        benefits2:
          "At yslearn.in your content is your own. Teach with us for free.  Any revenues you generate are your own, we don't charge a fee when using our free version.",
        "Go Multilingual": "Go Multilingual",
        benefits3:
          "The world is a big. Communicate its wonders in your language. Create courses in the languages of your choice to reach learners at home and abroad.",
        "Intellectual Property": "Intellectual Property",
        benefits4:
          "The materials you create belong to you. yslearn.in makes no claims and demands no exclusive use of the material you use on the platform.",
        "Barrier Free": "Barrier Free",
        benefits5:
          "yslearn.in and its teaching and learning tools are 100% compliant with WCAG, ADA and AODA guidelines and legislation.",
        "No Start-Up Costs": "No Start-Up Costs",
        benefits6:
          "The only up-front investment you need to make is with your time and creativity. yslearn.in has everything you need to deliver your course.",
        "Reputation Builders": "Marketing Support",
        benefits7:
          "yslearn.in features captivating instructors in Instructor Spotlights on our blog and social media channels. The links are easy to share to grow your reputation.",
        "No Payment Thresholds": "No Payment Thresholds",
        benefits8:
          "Once you start selling courses, your earnings will be paid out monthly. You don’t have to reach a certain threshold to cash out.",
        "Choose Your Currency": "Choose Your Currency",
        benefits9:
          "Living in Germany while your bank account is in Canada? No worries. Students pay in their currency, you are paid in yours.",
      },

      about: {
        "yslearn.in Story": "The yslearn.in Story",
        "Explore yslearn.in": "Explore Career Opportunities with yslearn.in",
        "Careers yslearn.in": "Careers with yslearn.in",
        "Our Solutions": "Our Solutions",
        "Strategic Partner": "Our Strategic Partner",
        "Leadership and Vision": "Leadership and Vision",
        "yslearn.in Leadership": "Leadership & Vision",
        "Values and Mission": "yslearn.in’s Mission and Values",
        "Corporate Responsibility": "Corporate Responsibility",
        "Global Partnerships": "Our Global Partnerships",
        "Leadership Vision": "Leadership & Vision",

        WeAreProud: "Our proud global re-sellers:",
        OurIntClients: "Our international clients:",
        "Our Vision": "Our Vision",
        "Our Mission": "Our Mission",
        visionDesc1:
          "Our global culture of inter-connectedness should fulfill the promise of access to information, knowledge and expertise!",
        visionDesc2:
          "yslearn.in was built on the belief that everyone should have access to education!",
        LifeAtsmiklearn: "Life At yslearn.in",

        ExpExcitingOpps: "Explore opportunities with yslearn.in",
        FromOurBlog: "From our Blog",
        UpOfWeek: "Update of the Week",
        InPress: "In the Press",
        ExpHelpdesk: "Explore Helpdesk",
        InstStories: "Instructor Stories",

        "Co-Founder": "Co-Founder",
        "Head of Operations": "Head of Operations",
      },

      pricing: {
        "Pricing Intro":
          "Choose from one of our packages, or contact us to discuss a custom solution and pricing",
        "Most Popular": "Most Popular",
        "No Risk": "Security, scalability and affordability in one package",
        "Best Value": "Best Value",
        "All our plans include": "All our plans include the following",
        Monthly: "Monthly",
        Yearly: "Yearly",
        Pricing: "Pricing",
        "Custom pricing":
          "Get in touch with our Sales team today for your custom pricing quote",
        "Book a Demo": "Book a Demo",
        "per year": "per year",
        "billed annually": "billed annually",
        Purchase: "Purchase",
        "Contact Sales": "Contact Sales",

        unlmtCourses: "Unlimted courses & activities",
        "Web conferencing": "Web conferencing",
        "Webinar recording": "Webinar recording",
        "File sharing": "File sharing",
        "Visual scheduling": "Visual scheduling",
        "Community forum": "Community forum",
        Reporting: "Reporting",
        "Analytics dashboard": "Analytics dashboard",
        "Concurrent sessions": "Concurrent sessions",
        "Secure SSL certification": "Secure SSL certification",
        "Automated backup & restore": "Automated backup & restore",
        "Customer support": "Customer support",
      },

      ExploreProgram:{
        "Explore Our Top Programs":"Future-Proof Your Career with Our Best Programs",
        "career goals":"Discover a wide range of courses designed to help you achieve your career goals"
      },
      form: {
        "First Name": "First Name",
        "Last Name": "Last Name",
      },

      "Instructor Benefits": "Instructor Benefits",
      "Create Account": "Create Account",
      "Be an Instructor": "Become an instructor",
      Instructor: "Instructor",
      Total: "Total",
      Items: "Items",
      Remove: "Remove",
      "Shopping Cart": "Shopping Cart",
      "Empty your cart": "Empty your cart",
      "Buy Later": "Buy Later",
      "Taxes will be added at checkout if applicable":
        "Taxes will be added at checkout if applicable",
      "Secure checkout": "Secure checkout",
      SubTotal: "SubTotal",
      "Shopping Cart Empty": "Your Shopping Cart is currently empty!",
      Hey: "Hey",
      "Find Something Interesting":
        "Here's where you might find something interesting",
      "Add to Wishlist": "Add to Wishlist",
      Reviews: "Reviews",
      "Course Highlights": "Course Highlights",
      "Related Courses": "Related Courses",
      "Course Requirements": "Course Requirements",
      "Course Description": "Course Description",
      "Course FAQs": "Course FAQs",
      "Course Syllabus": "Course Syllabus",
      Includes: "Includes",
      "Enroll for this course": "Enroll for this course",
      "Instructor Profile": "Instructor Profile",
      "Rate this Course?": "Rate this Course?",
      "Last Updated": "Last Updated",
      "Course Content": "Course Content",
      Languages: "Language",
      "Questions for the Instructor?": "Questions for the Instructor?",
      smiklearn: "yslearn.in",
      heroBannerTittle: "Adaptive Learning",
      welcome: "Courses for the Curious, the Inspired, and the Ambitious",
      introduction:
        "Discover a new way of learning LIVE or at your own pace with yslearn.in today",
      introduction1:"Power Your Career with World-Class Learning. Unlock 100+ courses, Professional Certificates, and certificates  programs from top-tier institutes and industry-leading companies. Whether you are:  Launching your career from scratch, Pivoting into a new field, or Accelerating your professional growth,  We give you the cutting-edge skills, certifications, and credentials to stand out—and dominate—in todays fast-moving job market. <br />🔥<strong> Why Learn With Us? </strong> <ol><li>✅ Learn from the Best: Ivy League professors and Fortune 500 experts at your fingertips.</li><li>✅ Get Job-Ready: Gain in-demand skills with hands-on projects and industry-recognized certifications.</li><li>✅ Learn Your Way: 100% flexible—study at your pace, on your schedule.",
      courseEnroll:"Launch your career as a Python developer with job-ready skills from Microsoft.",
      joinForFree:"Join For Free",
      trySimklearnforBusiness:"For Business",
      enterpriseEdition: "Click here for Enterprise Edition",
      Blog: "Blog",
      Login: "Log in",
      Signup: "Sign up",
      Features: "Features",
      Pricing: "Pricing",
      "Take your passion":
        "Bring your passion for teaching to the global classroom",
      learnBeyondBoundaries:
        "Virtual learning knows no boundaries, no barriers. Embrace the world of knowledge.",
      checkoutFeatures: "Checkout our features",

      "Login Intro": "Login Intro",
      or: "or",
      "Connect with social media": "Connect with social media:",

      "Become an Instructor": "Become an Instructor",
      Hello: "Search what you want to learn today",
      "What do you want to learn today": "What do you want to learn today",
      whoIsUsing: "Who's using",
      featuredOn: "Featured on",
      "featured instructor": "Featured Instructor",

      "Expert Instructors": "Expert Instructors",
      "Expert Instructors Description":
        "smiklearn’s instructors are well qualified to ensure high quality content in every course.",
      "Adaptive Learning": "Real Time Updates",
      "Adaptive Learning Description":
        "See your progress in real time and organize your course schedule.",
      "Convinient & Safe": "Interactive Tools",
      "Convinient & Safe Description":
        "Live Webinars, whiteboards, and engaging content to inspire learning.",
      "Live & Interactive": "Powered by Choice",
      "Live & Interactive Description":
        "Self-paced courses to complete on your schedule and recorded live webinars.",

      "Connect with us": "Connect with us",
      "Coming Soon": "Coming Soon",
      "About Us": "About Us",
      "About yslearn.in": "About yslearn.in",
      "yslearn.in Helpdesk": "yslearn.in Helpdesk",
      FAQs: "FAQs",
      "Webinars & Events": "Webinars & Events",
      "News & Press": "News & Press",
      "Cookie Policy": "Cookie Policy",
      "yslearn.in Blog": "yslearn.in Blog",
      "All Categories": "All Categories",
      "Checkout all": "Checkout all",
      courses: "courses",
      "All Courses": "All Courses",
      "For Post Secondary": "For Post Secondary",
      "For Corporate Training": "For Corporate Training",
      Careers: "Careers",
      "Edu-versity": "Edu-versity",
      "yslearn.in Community": "yslearn.in Community",
      "Knowledge Base": "Knowledge Base",

      events: "Events",
      learnMore: "Learn More",
      sitemap: "Sitemap",
      "Help and Support": "Help and Support",
      terms: "Terms",
      "Privacy Policy": "Privacy Policy",

      home: "Home",
      "Contact Us": "Contact Us",
      "Go to Home": "Go to Home",
      whoops: "We are updating some of the pages on the site to serve you better with our new features and programs.",
      Subscribe: "Subscribe",
      thankYou: "Thank You!",
      noThanks: "No, Thanks",
      subscribeNow: "Subscribe now and save an extra 10%!",
      useDiscountCode: "Use Discount Code",
      Enterprise: "For Enterprise",
      forUCI: "For Universities, Colleges & Institutes",
      corpTraining: "Corporate Training",
      whiteLabelSols: "White Label Solutions",

      noSpam:
        "We promise not to sell or trade your information to any third party ever and you can opt-out at anytime.",

      "For Enterprise Title": "Empowering Workforces Everywhere",
      "For Enterprise Description":
        "Live and self-paced enterprise training platform with easy program creation and progress tracking for professionals.",
      "For Enterpirse WhiteLabel Intro1":
        "yslearn.in is a versatile and efficient enterprise learning platform for streamlined operations,",
      "For Enterpirse WhiteLabel Intro2":
        " reduced costs, and increased profitability.",
      "Before Enterprise Power of yslearn.in Title1":
        "MORE THEN JUST A ",
      "Before Enterprise Power of yslearn.in Title2": "TOOL",
      Search: "Search",
      Language: "EN",
      numResults: "There are <1>{{count}}</1> results.",

      firstName: "First Name",
      fullName: "Full Name",
      lastName: "Last Name",
      email: "Email",
      username: "Username",
      phoneNo: "Phone Number",
      password: "Password",
      confPassword: "Confirm Password",
      continue: "Continue",
      forgotPassword: "Forgot Password?",
      letsgStr: "Let's get started",
      connLearEdu:
        "Welcome to our platform, where learners, educators, Log in to access your personalized dashboard, connect with peers and mentors, and unlock a world of learning opportunities tailored just for you",
      alreadyRegistered: "Already Registered?",
      wannaReg: "I want to register as a:",
      notRegistered: "Not Registered yet?",
      stNameNum: "Street Number & Name",
      unitNum: "Unit Number",
      city: "City",
      state: "provState",
      postalZipCode: "Zip/Postal Code",
      country: "Country",
      back: "Back",
      comRegistration: "Complete Registration",

      "Accessibility Statement": "Accessibility Statement",
      AccHomeDesc:
        "yslearn.in provides access to education beyond boundaries and without barriers. Our tools for both learners and instructors are ADA(Americans with Disabilities Act) and AODA(Accessibility for Ontarians with Disabilities Act) compliant.",

      "Preview Course": "Course Preview",
      "Buy Course": "Buy Course",
      "Testimonials Title":
        "Our customers trust yslearn.in's rich platform to help them deliver exceptional experiences and beyond",

      cookieStmt:
        "yslearn.in.com uses cookies to manage and improve your user experience on repeat visits to the site by remembering your past choices. We do not sell, trade, or use your data for advertising purposes. If you agree to use our cookies, please accept and continue to use our site. For more information please refer to our",
      acceptContinue: "Accept and Continue",

      getMoreInfo: "Get more Information",
      faqs: "Frequently Asked Questions",
      faqdesc: "Everything yslearn.in for Instructors and Learners",
      SearchFaqSection: "Search the FAQs section",
      moreInfo: "More Info",
      addToCart: "Add to Cart",
      goToCart: "Go to Cart",
      Keyword: "Keyword",
      Go: "Go",
      Section: "Section",
      "Purchased Course": "Purchased Course",
      features: {
        Dashboard: "Dashboards",
        "For Learners": "For Learners",
        "For Enterprise": "For Enterprise",
        "Webinar Features": "Webinar Features",
        "Built for Enterprise": "Built for Enterprise",
        "White Label Solutions": "White Label Solutions",
        "yslearn.in System": "yslearn.in System",
      },
      contact: {
        "Contact Success": "Your contact details were sent successfully!",
        "Success Message":
          "We appreciate you for giving us the opportunity to serve you, someone from our team will be in touch with you in the next 48 hours!",
        "Covid Message":
          "Please fill the form to request a callback and someone will get back to you very shortly. Thank You!",
        "Request CB": "Request a Call Back",
      },
    },
  },
  fr: {
    translation: {
      nav: {
        one: "Uno",
        Home: "Page d'accueil",
        Language: "La langue",
        English: "English",
        French: "Français",
        German: "Deutsch",
        Portugese: "Português",
        Spanish: "Español",
        Japanese: "日本語",
        Hindi: "हिंदी",
        Russian: "Русский",

        courses: "Cours",
      },

      general: {
        add: "Ajouter",
        close: "Fermer",
        cancel: "Annuler",
      },

      sideMenu: {
        dashboard: "Tableau de bord",
        courses: "Cours",
        createCourse: "Créer un cours",
        shopCourses: "Magasiner les cours",
        myWishlist: "Ma liste d'envies",
        webinars: "Séminaire en ligne",
        results: "Résultats",
        notes: "Remarques",
        forum: "Forum",
        grades: "Grades",
        achievements: "Réalisations",
        announcements: "Annonces",
        accounts: "Comptes",
      },

      status: {
        ns: "Pas Commencé",
        st: "En cours",
        co: "Complété",
        caf: "Effacer tous les filtres",
        courseProgress: "Progression du cours",
        filterStatus: "Filtrer par statut",
        addCourse: "Ajouter un Cours",
      },

      results: {
        resultReports: "Rapports de résultats",
      },

      notes: {
        welcome2Notes:
          "Bienvenue dans la fonction d'interactivité aux notes virtuelles d'yslearn.in",
        instructions: "Cliquez sur Ajouter des notes pour commencer",
        addNote: "Ajouter une note",
        deleteNote: "Supprimer la note",
        deleteConfMsg1: "Voulez-vous vraiment supprimer cette note?",
        deleteConfMsg2:
          "A la confirmation, cette note sera supprimée définitivement!",
        deleteConfBtn: "Confirmation de la suppression",
      },

      404: {
        backToDash: "Retour au tableau de bord",
        oops: "Oups la page que vous recherchez",
        doesNotExist: "n'existe pas",
      },

      profile: {
        profile: "Profil",
        moderation: "Modération",
        payments: "Paiements",

        // firstName: "Prénom",
        // lastName: "Nom de famille",
        bio: "Courte biographie",
        email: "Email",
        mobile: "Téléphone portable",
        save: "Sauvegarder",
        isAddressSame:
          "L'adresse de livraison est-elle la même que l'adresse de facturation?",
        address1: "Adresse Ligne 1",
        address2: "Adresse Ligne 2",
        cardHolderName: "Nom du titulaire",
        cardNo: "Numéro de carte",
        city: "Ville",
        stateProvince: "état ou province",
        expiry: "Expiration",
        postalZipCode: "Code postal ou zip",
        cvv: "CVV",
        country: "Pays",
      },

      tabs: {
        "Learn a new skill today": "Learn a new skill today",
        forLiveCourses: "apprenez une nouvelle compétence aujourd'/hui",
        chooseLiveWebinar:
          "Choisissez des cours en direct basés sur des webinaires ou des cours d'auto-apprentissage basés sur des vidéos.",
      },

      careers: {
        Careerswsmiklearn: "Carrières avec yslearn.in",
        curOppwEdu: "Opportunités ouvertes actuelles avec yslearn.in",
        ExpCareers:
          "Explorez des opportunités passionnantes avec yslearn.in, aidez à co-inventer le paysage LMS pour l'avenir",
        ExpCurOpp: "Explorer les postes ouverts",
      },

      instructorToolkit: {
        title:
          "La boîte à outils de l'instructeur yslearn.in : votre conception, votre cours, votre pédagogie",
        description:
          "Avez-vous créé un cours d'auto-apprentissage? Vivez-vous pour l'instruction en direct? Un mélange des deux ? La plateforme yslearn.in est là pour vous aider à la mélanger pour tous les styles d'apprentissage.",

        "Pre-Recorded Video": "Vidéo préenregistrée",
        desc1:
          "Pre-recorded videos give students the flexibility they need to start, stop and replay as often as they need to process course material. Upload your existing MP4 video chapters for each section of your course.",
        "Live Webinars": "Webinaires en direct",
        desc2:
          "Sometimes, to understand the coordination of ideas, we need to see our instructors conduct demonstrations or interact in real time. Schedule synchronous learning opportunities using our webinar feature.",
        "Slide Shows": "Diaporamas",
        desc3:
          "Visual learners need accompanying images to support their understanding of new vocabulary terms. Share PowerPoint presentations to combine the two and communicate with structure and clarity.",
        "Quizzes & Exams": "Quiz et examens",
        desc4:
          "Compose multiple choice, reflective and descriptive questions to test the knowledge your students have acquired by taking your course. Set specific pass levels and use integrated marking tools to automate assessments.",
        "Articles and Resources": "Articles et ressources",
        desc5:
          "The depth and detail of articles and other text resources is unbeatable for linguistic learners. Post your e-books, pdfs, docs and other resources to the course page for easy reference and central storage.",
        "Distribute Certificates": "Distribuer des certificats",
        desc6:
          "The reward for a job well done is a course certificate. Celebrate the skills your students have gained by taking your course and examination by issuing a custom electronic certificate of completion delivered via the yslearn.in platform.",
      },

      teacherIntro: {
        IntroTitle: "Devenir instructeur avec yslearn.in",
        IntroDesc1:
          "Vos apprenants vous remercient-ils pour votre travail ? Êtes-vous toujours en train de découvrir de nouvelles façons d'exprimer des concepts difficiles ? Prévoyez-vous des activités qui appliquent les connaissances pour innover et inspirer? Connaissez-vous la satisfaction d'aider les étudiants à réaliser leurs rêves?",
        IntroDesc2:
          "yslearn.in travaille avec les meilleurs instructeurs en ligne au monde. Vous pourriez être l'un d'entre eux.",
        IntroDesc3:
          "Créez un profil ! Oui, nous posons beaucoup de questions pour nous assurer que vous êtes bien qualifié, consciencieux et en sécurité. Montrez-nous vos diplômes, votre portefeuille et les relations que vous avez construites grâce à une réputation propre sur les réseaux sociaux.",
        IntroDesc4:
          "Créez un cours à l'aide de notre outil de glisser-déposer pour télécharger vos propres supports pédagogiques. Vendez votre cours aux apprenants nouveaux et existants. Taguez-nous dans vos publications sur les réseaux sociaux et nous partagerons ce que vous avez.",
        IntroDesc5:
          "yslearn.in vous aide à cultiver la curiosité, l'inspiration et l'ambition. C'est ce que font les meilleurs instructeurs.",
      },

      teacherBenefits: {
        "You Teach, We Screen": "Vous enseignez, nous examinons",
        benefits1:
          "Que vous enseigniez la beat box ou la physique, nous vérifions vos qualifications et votre expérience. Il protège nos étudiants, votre réputation et la nôtre!",
        "Teach for Free": "Transparent et juste",
        benefits2:
          "yslearn.in ne facture que 5% de commission de scolarité pour l'utilisation de notre plate-forme lorsque vous faites venir les étudiants. Si notre marketing attire des étudiants, nous facturons 30%.",
        "Go Multilingual": "Devenir multilingue",
        benefits3:
          "Le monde est grand. Communiquez ses merveilles dans votre langue. Créez des cours dans les langues de votre choix pour atteindre les apprenants chez vous et à l'étranger.",
        "Intellectual Property": "Propriété intellectuelle",
        benefits4:
          "Les matériaux que vous créez vous appartiennent. yslearn.in ne fait aucune réclamation et n'exige aucune utilisation exclusive du matériel que vous utilisez sur la plate-forme.",
        "Barrier Free": "Sans barrière",
        benefits5:
          "yslearn.in et ses outils d'enseignement et d'apprentissage sont 100% conformes aux normes d'accessibilité WCAG, ADA et AODA (Accessibilité pour les personnes handicapées de l'Ontario).",
        "No Start-Up Costs": "Aucun frais de démarrage",
        benefits6:
          "Le seul investissement initial que vous devez faire est avec votre temps et votre créativité. yslearn.in a tout ce dont vous avez besoin pour dispenser votre cours.",
        "Reputation Builders": "Bâtisseurs de réputation",
        benefits7:
          "yslearn.in présente des instructeurs captivants dans Instructor Spotlights sur notre blog et nos réseaux sociaux. Les liens sont faciles à partager pour développer votre réputation.",
        "No Payment Thresholds": "Aucun seuil de paiement",
        benefits8:
          "Une fois que vous commencez à vendre des cours, vos gains seront payés mensuellement. Vous n'avez pas besoin d'atteindre un certain seuil pour encaisser.",
        "Choose Your Currency": "Choisissez votre devise",
        benefits9:
          "Vivre en Allemagne alors que votre compte bancaire est au Canada ? Pas de soucis. Les étudiants paient dans leur devise, vous êtes payé dans la vôtre.",
      },

      about: {
        "yslearn.in Story": "L'histoire d'yslearn.in",
        "Explore yslearn.in": "Explorez les opportunités de carrière avec yslearn.in",
        "Careers yslearn.in": "Carrières avec yslearn.in",
        "Leadership Vision": "Direction et Vision",
        "Our Solutions": "Nos Solutions",
        "Strategic Partner": "Notre partenaire stratégique",
        "Leadership and Vision": "Leadership et vision",
        "yslearn.in Leadership": "Direction et Vision",
        "Values and Mission": "Valeurs et mission",
        "Corporate Responsibility": "La responsabilité des entreprises",
        "Global Partnerships": "Nos partenariats mondiaux",

        WeAreProud:
          "Nous sommes fiers de nous associer aux marques mondiales suivantes:",
        OurIntClients: "Nos fiers clients internationaux:",
        "Our Vision": "Notre Vision",
        "Our Mission": "Notre Mission",
        visionDesc1:
          "Notre culture mondiale de l'interconnectivité doit tenir la promesse de l'accès à l'information, au savoir et à l'expertise !",
        visionDesc2:
          "yslearn.in s'est construit sur la conviction que tout le monde devrait avoir accès à l'éducation!",
        LifeAtsmiklearn: "Vie At yslearn.in",

        ExpExcitingOpps: "Explorez les opportunités avec yslearn.in",
        FromOurBlog: "De notre Blog",
        UpOfWeek: "Mise à jour de la semaine",
        InPress: "Dans la presse",
        ExpHelpdesk: "Explorer le service d'assistance",
        InstStories: "Histoires d'instructeurs",

        "Co-Founder": "Co-Fondateur",
        "Head of Operations": "Chef des Opérations",
      },

      pricing: {
        "Most Popular": "Le plus populaire",
        "No Risk":
          "Sécurité, évolutivité et accessibilité dans un seul package",
        "Best Value": "Meilleure valeur",
        "All our plans include":
          "Tous nos plans incluent les éléments suivants",
        Monthly: "Mensuel",
        Yearly: "Annuel",
        Pricing: "Tarification",
        "Custom pricing":
          "Contactez nos ventes aujourd'hui pour votre devis personnalisé",
        "Book a Demo": "Réservez une démo",
        "per year": "par an",
        "billed annually": "facturé annuellement",
        Purchase: "Acheter",
        "Contact Sales": "Contacter le service commercial",

        unlmtCourses: "Cours & activités illimités",
        "Web conferencing": "Conférence Web",
        "Webinar recording": "Enregistrement du webinaire",
        "File sharing": "Partage de fichiers",
        "Visual scheduling": "Ordonnancement visuel",
        "Community forum": "Forum de la communauté",
        Reporting: "Rapports",
        "Analytics dashboard": "Tableau de bord analytique",
        "Concurrent sessions": "Sessions simultanées",
        "Secure SSL certification": "Certification SSL sécurisée",
        "Automated backup & restore": "Sauvegarde et restauration automatisées",
        "Customer support": "Service client",
      },

      "Instructor Benefits": "Avantages pour l'instructeur",
      "Create Account": "Créer un compte",
      "Be an Instructor": "Soyez un instructeur",
      Instructor: "Instructeur",
      Total: "Le total",
      Items: "Articles",
      Remove: "Supprimer",
      "Shopping Cart": "Panier",
      "Buy Later": "Acheter plus tard",
      "Empty your cart": "Vider votre panier",
      "Taxes will be added at checkout if applicable":
        "Les taxes seront ajoutées à la caisse si applicable",
      "Secure checkout": "Paiement sécurisé",
      SubTotal: "Total",
      "Shopping Cart Empty": "Votre panier d'achats est actuellement vide!",
      "Find Something Interesting":
        "Voici où vous pourriez trouver quelque chose d'intéressant",
      Hey: "Hey",
      "Add to Wishlist": "Ajouter à la liste",
      Reviews: "Commentaires",
      "Course Highlights": "Faits saillants du cours",
      "Related Courses": "Cours Connexes",
      "Course Requirements": "Prérequis du cours",
      "Course Description": "Description du cours",
      "Course FAQs": "FAQ sur les cours",
      "Course Syllabus": "Syllabus",
      "Enroll for this course": "Inscrivez-vous à ce cours",
      "Instructor Profile": "Profil de l'instructeur",
      "Rate this Course?": "Évaluez ce cours?",
      Includes: "Y compris",
      "Last Updated": "Dernière mise à jour",
      "Course Content": "Le contenu des cours",
      Languages: "Langue",
      "Questions for the Instructor?": "Des questions pour l'instructeur?",
      smiklearn: "yslearn.in",
      Login: "Se connecter",
      Signup: "S’inscrire",
      Features: "Caractéristiques",
      welcome: "Cours pour les curieux, les inspirés et les ambitieux",
      introduction:
        "Découvrez une nouvelle façon d'apprendre avec yslearn.in dès aujourd'hui!",
      enterpriseEdition: "Cliquez ici pour l'édition Entreprise",
      Blog: "Blog",
      Pricing: "Tarification",
      "Take your passion":
        "Emportez votre passion pour l'enseignement dans les salles de classe du monde entier",
      learnBeyondBoundaries:
        "L'apprentissage virtuel ne connaît ni frontières, ni barrières. Embrasser le monde de la connaissance.",
      checkoutFeatures: "Découvrez nos fonctionnalités",
      "Login Intro": "Ouverture de session",
      or: "ou",
      "Connect with social media": "Connectez-vous avec les médias sociaux:",

      "Teach with yslearn.in": "Enseigner avec yslearn.in",
      Hello:
        "Bonjour, cherchez-vous à apprendre quelque chose de nouveau aujourd'hui?",
      whoIsUsing: "Qui utilise yslearn.in?",
      featuredOn: "Présenté sur",

      "Expert Instructors": "Instructeurs experts",
      "Expert Instructors Description":
        "Nos normes sont élevées. Les instructeurs d'yslearn.in doivent passer par notre examen minutieux pour s'assurer que des cours bien planifiés sont dispensés par des experts qualifiés investis dans la réussite de leurs étudiants.",
      "Adaptive Learning": "Apprentissage adaptatif",
      "Adaptive Learning Description":
        "Visualisez vos progrès en temps réel, organisez votre programme de cours et suivez les devoirs et les quiz. Notre tableau de bord intègre des calendriers et des outils de planification pour vous aider à rester organisé et à gérer votre temps.",
      "Convinient & Safe": "Pratique et sûr",
      "Convinient & Safe Description":
        "Notre salle de classe virtuelle a tout ce dont vous avez besoin pour vous connecter avec d'autres apprenants et vos instructeurs. Un tableau blanc interactif présente des opportunités de remue-méninges et de résolution de problèmes. Participez à des discussions de groupe par voix ou par texte. Soumettez et commentez les devoirs dans les forums.",
      "Live & Interactive": "En direct et interactif",
      "Live & Interactive Description":
        "Peur de rater un cours ? Les webinaires en direct d'yslearn.in sont enregistrés pour une visualisation future. Vous avez le pouvoir de choisir non seulement ce que vous apprenez, mais quand vous l'apprenez.",

      "Connect with us": "Connecte-toi avec nous",
      "Coming Soon": "Bientôt disponible",
      "About Us": "À propos de nous",
      "About yslearn.in": "À propos de yslearn.in",
      "yslearn.in Helpdesk": "Service d'assistance yslearn.in",
      "yslearn.in Community": "Communauté yslearn.in",
      "Webinars & Events": "Webinaires et événements",
      FAQs: "FAQ",
      "News & Press": "Actualités & Presse",
      "Cookie Policy": "Politique relative aux cookies",
      "yslearn.in Blog": "yslearn.in Blog",
      "All Categories": "Toutes Catégories",
      "Checkout all": "Voir tout",
      courses: "cours",
      "All Courses": "Tous les cours",
      "For Post Secondary": "Pour le postsecondaire",
      "For Corporate Training": "Pour la formation en entreprise",
      Careers: "Carrières",
      "yslearn.in Community": "yslearn.in Communauté",
      "Knowledge Base": "Base de connaissances",

      "Accessibility Statement": "Déclaration d'accessibilité",
      AccHomeDesc:
        "yslearn.in donne accès à l'éducation au-delà des frontières et sans barrières. Nos outils pour les apprenants et les instructeurs sont conformes à l'ADA (Americans with Disabilities Act) et à l'AODA (Accessibility for Ontarians with Disabilities Act).",

      events: "Événements",
      learnMore: "Apprendre encore plus",
      sitemap: "Plan du site",
      "Help and Support": "Aide et soutien",
      terms: "Termes",
      "Privacy Policy": "Politique de confidentialité",

      Search: "Chercher",
      Language: "FR",

      home: "Maison",
      "Contact Us": "Nous Contacter",
      "Go to Home": "Aller à la maison",
      whoops: "Oups, ce que vous cherchez n'est pas trouvé!",
      Subscribe: "S'abonner",
      thankYou: "Merci!",
      noThanks: "Non merci",
      subscribeNow:
        "Abonnez-vous maintenant et économisez 10% supplémentaires!",
      useDiscountCode: "Utiliser le code de réduction",
      Enterprise: "Pour l'entreprise",
      forUCI: "Pour les universités, collèges et instituts",
      corpTraining: "Formation en entreprise",
      whiteLabelSols: "Solutions en marque blanche",

      "For Enterprise":
        "Des solutions de gestion de l'apprentissage cloud de niveau entreprise conçues dans un souci de sécurité, d'évolutivité et de sécurité!",
      "Blog Intro": "Explorez les articles rédigés par des experts",
      numResults: "Il y a <1>{{count}}</1> résultats.",

      firstName: "Prénom",
      fullName: "Nom et prénom",
      lastName: "Nom de famille",
      email: "Email",
      username: "Nom d'utilisateur",
      phoneNo: "Numéro de téléphone",
      password: "Mot de passe",
      confPassword: "Confirmez le mot de passe",
      continue: "Continuer",
      forgotPassword: "Mot de passe oublié?",
      letsgStr: "Commençons",
      connLearEdu:
        "Connecter les apprenants, les éducateurs et les parents du monde entier sur une plate-forme commune inclusive et véritablement multilingue.",
      alreadyRegistered: "Déjà enregistré?",
      wannaReg: "Je souhaite m'inscrire en tant que :",
      notRegistered: "Pas encore inscrit?",
      stNameNum: "Numéro et nom de la rue",
      unitNum: "Numéro d'unité",
      city: "Ville",
      state: "Province/État",
      postalZipCode: "Zip/code postal",
      country: "Pays",
      back: "Arrière",
      comRegistration: "Enregistrement Complet",

      "Preview Course": "Aperçu du cours",
      "Buy Course": "Acheter un cours",
      "Testimonials Title":
        "Nos clients font confiance à la riche plateforme d'yslearn.in pour les aider à offrir des expériences exceptionnelles et au-delà",

      cookieStmt:
        "yslearn.in.com utilise des cookies pour gérer et améliorer votre expérience utilisateur lors de visites répétées sur le site en mémorisant vos choix passés. Nous ne vendons, n'échangeons ni n'utilisons vos données à des fins publicitaires. Si vous acceptez d'utiliser nos cookies, veuillez accepter et continuer à utiliser notre site. Pour plus d'informations, veuillez consulter notre",
      acceptContinue: "Accepter et continuer",

      getMoreInfo: "Se procurer plus d'information",
      faqs: "Questions fréquemment posées",
      faqdesc: "Tout yslearn.in pour les instructeurs et les apprenants",
      SearchFaqSection: "Rechercher dans la section FAQ",
      moreInfo: "Plus d'informations",
      addToCart: "Ajouter au Panier",
      goToCart: "Aller au panier",
      Keyword: "Mot-clé",
      Go: "Aller",
      Section: "Section",
      "Purchased Course": "Cours Acheté",
      features: {
        Dashboard: "Tableau de bord",
        "For Learners": "Pour les apprenants",
        "For Enterprise": "Pour l'entreprise",
        "Webinar Features": "Fonctionnalités du webinaire",
        "Built for Enterprise": "Conçu pour l'entreprise",
        "White Label Solutions": "Solutions en marque blanche",
        "yslearn.in System": "Système éducatif",
      },
      contact: {
        "Contact Success": "Vos coordonnées ont été envoyées avec succès!",
        "Success Message":
          "Nous vous remercions de nous donner l'opportunité de vous servir, quelqu'un de notre équipe vous contactera dans les prochaines 48 heures!",
        "Covid Message":
          "En raison des restrictions liées au COVID-19, notre équipe travaille actuellement à distance. Veuillez remplir le formulaire pour demander un rappel et quelqu'un vous répondra très prochainement. Merci!",
        "Request CB": "Demander un rappel",
      },
    },
  },
  de: {
    translation: {
      nav: {
        one: "Uno",
        English: "English",
        French: "Français",
        German: "Deutsch",
        Portugese: "Português",
        Spanish: "Español",
        Japanese: "日本語",
        Hindi: "हिंदी",
        Russian: "Русский",

        courses: "Kurse",
      },

      tabs: {
        "Learn a new skill today": "Lerne heute eine neue Fähigkeit",
        forLiveCourses: "für LIVE Online-Kurse",
        chooseLiveWebinar:
          "Wählen Sie Live-Webinar-basierte Kurse oder Video-basierte Kurse zum Selbststudium.",
      },

      sideMenu: {
        dashboard: "Armaturenbrett",
        courses: "Kurse",
        createCourse: "Kurs Erstellen",
        shopCourses: "Kurse Einkaufen",
        myWishlist: "Meine Wunschliste",
        webinars: "Webinare",
        results: "Ergebnisse",
        notes: "Anmerkungen",
        forum: "Forum",
        grades: "Noten",
        achievements: "Erfolge",
        announcements: "Ankündigungen",
        accounts: "Konten",
      },

      status: {
        courseProgress: "Kursfortschritt",
      },

      careers: {
        Careerswsmiklearn: "Karriere bei yslearn.in",
        curOppwEdu: "Aktuelle offene Möglichkeiten mit yslearn.in",
        ExpCareers:
          "Entdecken Sie spannende Möglichkeiten mit yslearn.in, helfen Sie mit, die LMS-Landschaft für die Zukunft mitzuerfinden",
        ExpCurOpp: "Entdecken Sie offene Stellen",
      },

      about: {
        "yslearn.in Story": "Die yslearn.in-Geschichte",
        "Leadership and Vision": "Führung und Vision",
        "Explore yslearn.in": "Entdecken Sie Karrieremöglichkeiten mit yslearn.in",
        "Careers yslearn.in": "Karriere bei yslearn.in",
        "Our Solutions": "Unsere Lösungen",
        "Strategic Partner": "Unser strategischer Partner",
        "yslearn.in Leadership": "Führung & Vision",
        "Values and Mission": "Werte und Mission",
        "Corporate Responsibility": "Unternehmerische Verantwortung",
        "Global Partnerships": "Unsere globalen Partnerschaften",

        WeAreProud:
          "Wir sind stolz darauf, mit den folgenden globalen Marken zusammenzuarbeiten:",
        OurIntClients: "Unsere stolzen internationalen Kunden:",
        "Our Vision": "Unsere Vision",
        "Our Mission": "Unsere Aufgabe",
        visionDesc1:
          "Unsere globale Kultur der Vernetzung soll das Versprechen des Zugangs zu Informationen, Wissen und Expertise erfüllen!",
        visionDesc2:
          "yslearn.in basiert auf der Überzeugung, dass jeder Zugang zu Bildung haben sollte!",
        LifeAtsmiklearn: "Leben bei yslearn.in",

        ExpExcitingOpps: "Entdecken Sie Möglichkeiten mit yslearn.in",
        FromOurBlog: "Aus unserem Blog",
        UpOfWeek: "Update der Woche",
        InPress: "In der Presse",
        ExpHelpdesk: "Helpdesk Erkunden",
        InstStories: "Lehrerin Geschichten",

        "Co-Founder": "Mitgründer",
        "Head of Operations": "Leiter Operations",
      },

      pricing: {
        "Most Popular": "Am beliebtesten",
        "No Risk":
          "Sicherheit, Skalierbarkeit und Erschwinglichkeit in einem Paket",
        "Best Value": "Bester Wert",
        "All our plans include": "Alle unsere Pläne beinhalten Folgendes",
        Monthly: "Monatlich",
        Yearly: "Jährlich",
        Pricing: "Preisgestaltung",
        "Custom pricing":
          "Kontaktieren Sie unseren Vertrieb noch heute für Ihr individuelles Preisangebot",
        "Book a Demo": "Buchen Sie eine Demo",
        "per year": "pro Jahr",
        "billed annually": "jährlich abgerechnet",
        Purchase: "Kauf",

        unlmtCourses: "Unbegrenzte Kurse & Aktivitäten",
        "Web conferencing": "Webkonferenzen",
        "Webinar recording": "Webinar-Aufzeichnung",
        "File sharing": "Datenaustausch",
        "Visual scheduling": "Visuelle Planung",
        "Community forum": "Gemeinschaftsforum",
        Reporting: "Berichterstattung",
        "Analytics dashboard": "Analytics-Dashboard",
        "Concurrent sessions": "Gleichzeitige Sitzungen",
        "Secure SSL certification": "Sichere SSL-Zertifizierung",
        "Automated backup & restore":
          "Automatisierte Sicherung und Wiederherstellung",
        "Customer support": "Kundendienst",
      },

      "Instructor Benefits": "Vorteile für Ausbilder",
      "Be an Instructor": "Sei ein Ausbilder",
      Instructor: "Lehrer",
      Total: "Gesamt",
      Items: "Produkte",
      Remove: "Entfernen",
      "Shopping Cart": "Einkaufswagen",
      "Empty your cart": "Leerer Warenkorb",
      "Buy Later": "Später kaufen",
      "Taxes will be added at checkout if applicable":
        "Steuern werden gegebenenfalls an der Kasse hinzugefügt",
      "Secure checkout": "Sichere Kasse",
      SubTotal: "Zwischensumme",
      "Shopping Cart Empty": "Ihr Warenkorb ist zur Zeit leer!",
      "Find Something Interesting":
        "Hier finden Sie vielleicht etwas Interessantes",
      Hey: "Hallo",
      "Add to Wishlist": "Zur Liste hinzufügen",
      Reviews: "Bewertungen",
      "Course Highlights": "Kurs-Highlights",
      "Related Courses": "Ähnliche Kurse",
      "Course Requirements": "Kursvoraussetzungen",
      "Course Description": "Kursbeschreibung",
      "Course FAQs": "Kurs-FAQs",
      "Course Syllabus": "Lehrplan",
      Includes: "Einschließlich",
      "Enroll for this course": "Melden Sie sich für diesen Kurs an",
      "Instructor Profile": "Lehrerprofil",
      "Rate this Course?": "Bewerten Sie diesen Kurs?",
      "Last Updated": "Zuletzt aktualisiert",
      "Course Content": "Kursinhalt",
      Languages: "Sprache",
      "Questions for the Instructor?": "Fragen an den Dozenten?",
      smiklearn: "yslearn.in",
      welcome: "Kurse für Neugierige, Inspirierte und Ehrgeizige",
      introduction:
        "Entdecken Sie noch heute eine neue Art des Lernens mit yslearn.in!",
      enterpriseEdition: "Klicken Sie hier für die Enterprise Edition",
      Blog: "Blog",
      Login: "Anmelden",
      Signup: "Registrieren",
      Features: "Merkmale",
      Pricing: "Preisgestaltung",
      "Take your passion":
        "Bringen Sie Ihre Leidenschaft für das Unterrichten in die globalen Klassenzimmer",
      learnBeyondBoundaries:
        "Virtuelles Lernen kennt keine Grenzen, keine Barrieren. Tauchen Sie ein in die Welt des Wissens.",
      checkoutFeatures: "Schauen Sie sich unsere Funktionen an",
      "Login Intro": "Intro für Login",
      or: "oder",
      "Connect with social media": "Verbinden Sie sich mit sozialen Medien:",

      "Teach with yslearn.in": "Unterrichten Sie mit yslearn.in",
      Hello: "Hallo, möchtest du heute etwas Neues lernen?",
      whoIsUsing: "Wer nutzt yslearn.in?",
      featuredOn: "Gekennzeichnet auf",

      "About Us": "Über uns",

      "Expert Instructors": "Erfahrene Ausbilder",
      "Expert Instructors Description":
        "Unser Anspruch ist hoch. Die Lehrer von yslearn.in müssen unsere Prüfung bestehen, um sicherzustellen, dass gut geplante Unterrichtsstunden von qualifizierten Experten durchgeführt werden, die in den Erfolg ihrer Schüler investieren.",
      "Adaptive Learning": "Adaptives Lernen",
      "Adaptive Learning Description":
        "Sehen Sie Ihren Fortschritt in Echtzeit, organisieren Sie Ihren Kursplan und behalten Sie den Überblick über Aufgaben und Quizfragen. Unser Dashboard verfügt über integrierte Kalender und Planungstools, damit Sie organisiert bleiben und Ihre Zeit verwalten können.",
      "Convinient & Safe": "Bequem und sicher",
      "Convinient & Safe Description":
        "Unser virtuelles Klassenzimmer bietet alles, was Sie brauchen, um mit anderen Lernenden und Ihren Lehrern in Kontakt zu treten. Ein interaktives Whiteboard bietet Möglichkeiten zum Brainstorming und zur Problemlösung. Nehmen Sie an Gruppendiskussionen per Sprache oder Text teil. Senden und kommentieren Sie Aufgaben in den Foren.",
      "Live & Interactive": "Live & Interaktiv",
      "Live & Interactive Description":
        "Angst, eine Klasse zu verpassen? Die Live-Webinare von yslearn.in werden zur späteren Ansicht aufgezeichnet. Sie haben die Macht, nicht nur zu entscheiden, was Sie lernen, sondern auch wann Sie es lernen.",

      "Connect with us": "Verbinde dich mit uns",
      "Coming Soon": "Demnächst",
      "About yslearn.in": "Über yslearn.in",
      "Webinars & Events": "Webinare & Veranstaltungen",
      "News & Press": "Nachrichten & Presse",
      "Cookie Policy": "Cookie-Richtlinie",
      "yslearn.in Blog": "yslearn.in Blog",
      "All Categories": "Alle Kategorien",
      "Checkout all": "Alles sehen",
      courses: "kurse",
      "All Courses": "Alle Kurse",
      "For Post Secondary": "Für postsekundäre",
      "For Corporate Training": "Für Corporate Training",
      Careers: "Karriere",
      "yslearn.in Helpdesk": "yslearn.in Beratungsstelle",
      FAQs: "Häufig gestellte Fragen",
      "yslearn.in Community": "yslearn.in Gemeinschaft",
      "Knowledge Base": "Wissensbasis",

      "Accessibility Statement": "Erklärung zur Barrierefreiheit",
      AccHomeDesc:
        "yslearn.in bietet Zugang zu Bildung über Grenzen hinweg und ohne Barrieren. Unsere Tools für Lernende und Ausbilder sind ADA (Americans with Disabilities Act) und AODA (Accessibility for Ontarians with Disabilities Act) konform.",

      events: "Veranstaltungen",
      learnMore: "Erfahren Sie mehr",
      sitemap: "Seitenverzeichnis",
      "Help and Support": "Hilfe und Unterstützung",
      terms: "Bedingungen",
      "Privacy Policy": "Datenschutz-Bestimmungen",

      home: "Zuhause",
      insider: "Initiée",
      Enterprise: "Für Unternehmen",
      "For Enterprise":
        "Cloud-Learning-Management-Lösungen für Unternehmen, die auf Sicherheit, Skalierbarkeit und Sicherheit ausgelegt sind!",
      "Blog Intro": "Entdecken Sie Artikel von Experten",
      numResults: "Es gibt <1>{{count}}</1> ergebnisse.",

      Home: "Zuhause",
      "Contact Us": "Kontaktiere uns",
      Search: "Suche",
      Language: "DE",
      // Enterprise: "Für die Firma",
      forUCI: "Für Universitäten, Hochschulen und Institute",
      corpTraining: "Firmenschulung",
      whiteLabelSols: "White-Label-Lösungen",

      firstName: "Vorname",
      fullName: "Vollständiger Name",
      lastName: "Nachname",
      email: "Email",
      username: "Nutzername",
      phoneNo: "Telefonnummer",
      password: "Passwort",
      confPassword: "Kennwort bestätigen",
      continue: "Weitermachen",
      forgotPassword: "Passwort vergessen?",
      letsgStr: "Lass uns anfangen",
      connLearEdu:
        "Verbinden von Lernenden, Pädagogen und Eltern aus der ganzen Welt auf einer gemeinsamen inklusiven und wirklich mehrsprachigen Plattform.",
      wannaReg: "Ich möchte mich registrieren als:",
      alreadyRegistered: "Bereits registriert?",
      notRegistered: "Noch nicht registriert?",
      stNameNum: "Hausnummer & Name",
      unitNum: "Gerätenummer",
      city: "Stadt",
      state: "Provinz/Staat",
      postalZipCode: "Postleitzahl",
      country: "Land",
      back: "Zurück",
      comRegistration: "Komplette Registrierung",

      "Preview Course": "Kursvorschau",
      "Buy Course": "Kurs kaufen",
      "Testimonials Title":
        "Unsere Kunden vertrauen auf die reichhaltige Plattform von yslearn.in, die ihnen hilft, außergewöhnliche Erfahrungen und mehr zu liefern",

      thankYou: "Danke!",
      "Create Account": "Benutzerkonto erstellen",

      cookieStmt:
        "yslearn.in.com verwendet Cookies, um Ihre Benutzererfahrung bei wiederholten Besuchen der Website zu verwalten und zu verbessern, indem Sie sich an Ihre früheren Entscheidungen erinnern. Wir verkaufen, handeln oder verwenden Ihre Daten nicht zu Werbezwecken. Wenn Sie mit der Verwendung unserer Cookies einverstanden sind, akzeptieren Sie unsere Website und nutzen Sie sie weiter. Weitere Informationen finden Sie in unserem",
      acceptContinue: "Akzeptieren und weiter",

      getMoreInfo: "Mehr Informationen bekommen",
      faqs: "Häufig gestellte Fragen",
      faqdesc: "Alles yslearn.in für Lehrer und Lernende",
      SearchFaqSection: "Suchen Sie im FAQ-Bereich",
      moreInfo: "Mehr Info",
      addToCart: "Zum Warenkorb hinzufügen",
      goToCart: "Zum Einkaufskorb gehen",
      Keyword: "Stichwort",
      Go: "Aller",
      Section: "Section",
      "Purchased Course": "Gekaufter Kurs",
      features: {
        Dashboard: "Armaturenbrett",
        "For Learners": "Für Lernende",
        "For Enterprise": "Für Unternehmen",
        "Webinar Features": "Webinar-functies",
        "Built for Enterprise": "Gebouwd voor ondernemingen",
        "White Label Solutions": "White Label-oplossingen",
        "yslearn.in System": "yslearn.in-systeem",
      },

      teacherIntro: {
        IntroTitle: "Werden Sie Ausbilder mit yslearn.in",
        IntroDesc1:
          "Bedanken sich Ihre Lernenden für Ihre Arbeit? Entdecken Sie immer wieder neue Wege, um schwierige Konzepte auszudrücken? Planen Sie Aktivitäten, die Wissen anwenden, um zu innovieren und zu inspirieren? Kennen Sie die Befriedigung, Schülern dabei zu helfen, ihre Träume zu verwirklichen?",
        IntroDesc2:
          "yslearn.in arbeitet mit den besten Online-Trainern der Welt zusammen. Sie könnten einer von ihnen sein.",
        IntroDesc3:
          "Erstelle ein Profil! Ja, wir stellen viele Fragen, um sicherzustellen, dass Sie gut qualifiziert, gewissenhaft und sicher sind. Zeigen Sie uns Ihre Abschlüsse, Ihr Portfolio und die Beziehungen, die Sie durch einen sauberen Ruf in den sozialen Medien aufgebaut haben.",
        IntroDesc4:
          "Erstellen Sie mit unserem Drag-and-Drop-Tool einen Kurs, um Ihre eigenen Unterrichtsmaterialien hochzuladen. Verkaufen Sie Ihren Kurs an neue und bestehende Lernende. Markieren Sie uns in Ihren Social-Media-Beiträgen und wir teilen, was Sie haben.",
        IntroDesc5:
          "yslearn.in hilft Ihnen, Neugier, Inspiration und Ehrgeiz zu kultivieren. Das machen die besten Ausbilder.",
      },

      contact: {
        "Contact Success": "Ihre Kontaktdaten wurden erfolgreich versendet!",
        "Success Message":
          "Wir wissen es zu schätzen, dass Sie uns die Gelegenheit geben, Sie zu bedienen. Jemand aus unserem Team wird sich in den nächsten 48 Stunden mit Ihnen in Verbindung setzen!",
        "Covid Message":
          "Aufgrund von COVID-19-Einschränkungen arbeitet unser Team derzeit remote. Bitte füllen Sie das Formular aus, um einen Rückruf anzufordern, und jemand wird sich in Kürze bei Ihnen melden. Danke!",
        "Request CB": "Fordern Sie einen Rückruf an",
      },
    },
  },
  es: {
    translation: {
      nav: {
        one: "Uno",
        Language: "ES",
        English: "English",
        French: "Français",
        German: "Deutsch",
        Portugese: "Português",
        Spanish: "Español",
        Japanese: "日本語",
        Hindi: "हिंदी",
        Russian: "Русский",

        courses: "Cursos",
      },

      tabs: {
        "Learn a new skill today": "Aprenda una nueva habilidad hoy",
        forLiveCourses: "para cursos en línea EN VIVO",
        chooseLiveWebinar:
          "Elija cursos basados ​​en seminarios web en vivo o cursos basados ​​en videos de autoaprendizaje.",
      },

      sideMenu: {
        dashboard: "Panel",
        courses: "Cursos",
        createCourse: "Crear Curso",
        shopCourses: "Comprar cursos",
        myWishlist: "Mi lista de deseos",
        webinars: "Seminarios web",
        results: "Resultados",
        notes: "Notas",
        forum: "Foro",
        grades: "Los grados",
        achievements: "Logros",
        announcements: "Anuncios",
        accounts: "Cuentas",
      },

      status: {
        courseProgress: "Progreso del curso",
      },

      careers: {
        Careerswsmiklearn: "Carreras con yslearn.in",
        curOppwEdu: "Oportunidades abiertas actuales con yslearn.in",
        ExpCareers:
          "Explore oportunidades remotas, flexibles y emocionantes con yslearn.in, ayúdenos a inventar conjuntamente el panorama LMS para el futuro",
        ExpCurOpp: "Explorar posiciones abiertas",
      },

      pricing: {
        "Most Popular": "Más Popular",
        "No Risk":
          "Seguridad, escalabilidad y asequibilidad en un solo paquete",
        "All our plans include": "Todos nuestros planes incluyen lo siguiente",
        Monthly: "Mensual",
        Yearly: "Anual",
        Pricing: "Precios",
        "Custom pricing":
          "Póngase en contacto con nuestro departamento de ventas hoy mismo para obtener su cotización de precios personalizada",
        "Book a Demo": "Reserve una demostración",
        "per year": "por año",
        "Best Value": "Mejor valor",
        "billed annually": "facturado anualmente",
        Purchase: "Compra",

        unlmtCourses: "Cursos y actividades ilimitados",
        "Web conferencing": "Conferencias web",
        "Webinar recording": "Grabación de seminarios web",
        "File sharing": "Compartición de archivos",
        "Visual scheduling": "Programación visual",
        "Community forum": "Foro Comunitario",
        Reporting: "Reportando",
        "Analytics dashboard": "Panel de análisis",
        "Concurrent sessions": "Sesiones concurrentes",
        "Secure SSL certification": "Certificación SSL segura",
        "Automated backup & restore": "Respaldo y restauración automatizados",
        "Customer support": "Atención al cliente",
      },

      "Instructor Benefits": "Beneficios del instructor",
      "Be an Instructor": "Ser un instructor",
      Instructor: "Instructor",
      Total: "Total",
      Items: "Elementos",
      Remove: "Eliminar",
      "Shopping Cart": "Carro de compras",
      "Empty your cart": "Vacía tu carrito",
      "Buy Later": "Comprar más tarde",
      "Taxes will be added at checkout if applicable":
        "Los impuestos se agregarán al finalizar la compra si corresponde",
      "Secure checkout": "Pago seguro",
      SubTotal: "Total parcial",
      "Shopping Cart Empty": "¡Su cesta está vacía!",
      "Find Something Interesting":
        "Aquí es donde puedes encontrar algo interesante",
      Hey: "Oye",
      "Add to Wishlist": "Agregar a la lista",
      Reviews: "Reseñas",
      "Course Highlights": "Aspectos destacados del curso",
      "Related Courses": "Cursos Relacionados",
      "Course Requirements": "Prerrequisitos del curso",
      "Course Description": "Descripción del curso",
      "Course FAQs": "Preguntas frecuentes del curso",
      "Course Syllabus": "Programa del curso",
      "Enroll for this course": "Inscríbete a este curso",
      "Instructor Profile": "Perfil del instructor",
      Includes: "Incluso",
      "Rate this Course?": "¿Califica este curso?",
      "Last Updated": "Última actualización",
      "Course Content": "Contenido del curso",
      Languages: "Idioma",
      "Questions for the Instructor?": "¿Preguntas para el instructor?",
      smiklearn: "yslearn.in",
      welcome: "Cursos para curiosos, inspirados y ambiciosos",
      introduction: "¡Descubra una nueva forma de aprender con yslearn.in hoy!",
      enterpriseEdition: "Haga clic aquí para Enterprise Edition",
      Blog: "Blog",
      Login: "Iniciar sesión",
      Signup: "Regístrate",
      Features: "Características",
      Pricing: "Precios",
      "Take your passion":
        "Lleva tu pasión por la enseñanza a las aulas de todo el mundo",
      learnBeyondBoundaries:
        "El aprendizaje virtual no conoce fronteras ni barreras. Abraza el mundo del conocimiento.",
      checkoutFeatures: "Consulte nuestras características",
      "Login Intro": "Introducción de inicio de sesión",
      or: "o",
      "Connect with social media": "Conéctese con las redes sociales:",

      "Teach with yslearn.in": "Enseñe con yslearn.in",
      Hello: "Hola, ¿estás buscando aprender algo nuevo hoy?",
      whoIsUsing: "¿Quién usa yslearn.in?",
      featuredOn: "Presentado en",

      "About Us": "Sobre nosotros",

      "Expert Instructors": "Instructoras expertas",
      "Expert Instructors Description":
        "Nuestros estándares son altos. Los instructores de yslearn.in deben pasar por nuestro escrutinio para garantizar que las lecciones bien planificadas sean impartidas por expertos calificados que inviertan en el éxito de sus estudiantes.",
      "Adaptive Learning": "Aprendizaje adaptativo",
      "Adaptive Learning Description":
        "Vea su progreso en tiempo real, organice su programa de cursos y realice un seguimiento de las tareas y las pruebas. Nuestro tablero tiene calendarios integrados y herramientas de programación para ayudarlo a mantenerse organizado y administrar su tiempo.",
      "Convinient & Safe": "Conviniente y segura",
      "Convinient & Safe Description":
        "Nuestro aula virtual tiene todo lo que necesita para conectarse con otros estudiantes y sus instructores. Una pizarra interactiva presenta oportunidades para una lluvia de ideas y resolución de problemas. Participe en discusiones grupales por voz o por texto. Envíe y comente las asignaciones en los foros.",
      "Live & Interactive": "Viva e interactiva",
      "Live & Interactive Description":
        "Tienes miedo de perder una clase? Los seminarios web en directo de yslearn.in se graban para verlos en el futuro. Tiene el poder de elegir no solo lo que aprende, sino también cuándo lo aprende.",

      "Connect with us": "Conecta con nosotros",
      "Coming Soon": "Próximamente",
      "About yslearn.in": "Sobre yslearn.in",
      "Webinars & Events": "Webinare & Veranstaltungen",
      "News & Press": "Noticias y prensa",
      "Cookie Policy": "Política de cookies",
      "yslearn.in Blog": "yslearn.in Blog",
      "All Categories": "Todas las categorias",
      "Checkout all": "Ver todo",
      courses: "cursos",
      "All Courses": "Todos los cursos",
      "For Post Secondary": "Para estudios postsecundarios",
      "For Corporate Training": "Para formación corporativa",
      Careers: "Carreras",
      "yslearn.in Helpdesk": "Servicio de asistencia de yslearn.in",
      FAQs: "Preguntas Frecuentes",
      "yslearn.in Community": "Comunidad yslearn.in",
      "Knowledge Base": "Base de conocimientos",

      events: "Eventos",
      "Create Account": "Crear una cuenta",
      learnMore: "Aprende más",
      sitemap: "Mapa del sitio",
      "Help and Support": "Ayuda y apoyo",
      terms: "Condiciones",
      "Privacy Policy": "Política de privacidad",

      "Preview Course": "Vista previa del curso",
      "Buy Course": "Comprar curso",
      "Testimonials Title":
        "Nuestros clientes confían en la rica plataforma de yslearn.in para ayudarlos a brindar experiencias excepcionales y más allá",

      home: "Casa",
      "Contact Us": "Contacta con nosotros",
      Enterprise: "Para Negocios",
      "For Enterprise":
        "Soluciones de gestión de aprendizaje en la nube de nivel empresarial creadas teniendo en cuenta la seguridad, la escalabilidad y la seguridad!",
      "Blog Intro": "Explora artículos escritos por expertas",
      numResults: "Es gibt <1>{{count}}</1> ergebnisse.",
      Home: "Casa",
      Search: "Buscar",
      Language: "ES",
      // Enterprise: "Für die FirmaPara empresas",
      forUCI: "Para Universidades, Colegios e Institutos",
      corpTraining: "Formación empresarial",
      whiteLabelSols: "Soluciones de marca blanca",

      thankYou: "Gracias!",

      firstName: "Primer nombre",
      fullName: "Nombre completo",
      lastName: "Apellido",
      email: "Email",
      username: "Nombre de usuario",
      phoneNo: "Número de teléfono",
      password: "Contraseña",
      confPassword: "Confirmar Contraseña",
      continue: "Continuar",
      forgotPassword: "Has olvidado tu contraseña?",
      letsgStr: "Empecemos",
      connLearEdu:
        "Conectando a estudiantes, educadores y padres de todo el mundo en una plataforma común inclusiva y verdaderamente multilingüe.",
      wannaReg: "Quiero registrarme como:",
      alreadyRegistered: "Ya registrada?",
      notRegistered: "Todavía no estas registrado?",
      stNameNum: "Registro completo",
      unitNum: "Unidad numérica",
      city: "Ciudad",
      state: "Provincia/Ste",
      postalZipCode: "Código postal",
      country: "País",
      back: "Atrás",
      comRegistration: "Registro completo",

      "Accessibility Statement": "Declaración de accesibilidad",
      AccHomeDesc:
        "yslearn.in proporciona acceso a la educación más allá de las fronteras y sin barreras. Nuestras herramientas para estudiantes e instructores cumplen con la ADA (Ley de Estadounidenses con Discapacidades) y la AODA (Ley de Accesibilidad para los Ontarianos con Discapacidades).",

      cookieStmt:
        "yslearn.in.com utiliza cookies para administrar y mejorar su experiencia de usuario en visitas repetidas al sitio recordando sus elecciones pasadas. No vendemos, comercializamos ni utilizamos sus datos con fines publicitarios. Si acepta utilizar nuestras cookies, acepte y continúe utilizando nuestro sitio. Para obtener más información, consulte nuestro",
      acceptContinue: "Aceptar y continuar",

      getMoreInfo: "Obtener mas Informacion",
      faqs: "Preguntas frecuentes",
      faqdesc: "Todo yslearn.in para instructores y estudiantes",
      SearchFaqSection: "Busque en la sección de preguntas frecuentes",
      moreInfo: "Más Información",
      addToCart: "Añadir al Carrito",
      goToCart: "Ir al carrito",
      Keyword: "palabra clave",
      Go: "Vamos",
      Section: "Section",
      "Purchased Course": "Curso Comprado",
      features: {
        Dashboard: "Tablero",
        "For Learners": "Para Estudiantes",
        "For Enterprise": "Para Empresas",
        "Webinar Features": "Características del seminario web",
        "Built for Enterprise": "Creado para empresas",
        "White Label Solutions": "Soluciones de marca blanca",
        "yslearn.in System": "Sistema yslearn.in",
      },
      teacherIntro: {
        IntroTitle: "Conviértete en Instructor con yslearn.in",
        IntroDesc1:
          "Tus alumnos te agradecen tu trabajo? ¿Estás siempre descubriendo nuevas formas de expresar conceptos difíciles? ¿Planea actividades que aplican el conocimiento para innovar e inspirar? ¿Conoces la satisfacción de ayudar a los estudiantes a alcanzar sus sueños?",
        IntroDesc2:
          "yslearn.in trabaja con los mejores instructores en línea del mundo. Tu podrías ser uno de ellos.",
        IntroDesc3:
          "Crear un perfil! Sí, hacemos muchas preguntas para asegurarnos de que esté bien calificado, consciente y seguro. Muéstrenos sus títulos, su cartera y las relaciones que ha construido a través de una reputación limpia en las redes sociales.",
        IntroDesc4:
          "Cree un curso utilizando nuestra herramienta de arrastrar y soltar para cargar sus propios materiales educativos. Venda su curso a estudiantes nuevos y existentes. Etiquétanos en tus publicaciones en las redes sociales y compartiremos lo que tienes.",
        IntroDesc5:
          "yslearn.in te ayuda a cultivar la curiosidad, la inspiración y la ambición. Es lo que hacen los mejores instructores.",
      },
      about: {
        "yslearn.in Story": "La historia de la educación",
        "Explore yslearn.in": "Explore oportunidades profesionales con yslearn.in",
        "Careers yslearn.in": "Carreras con yslearn.in",
        "Strategic Partner": "Nuestro Socio Estratégico",
        "Leadership and Vision": "",
        "yslearn.in Leadership": "Liderazgo y Visión",
        "Values and Mission": "Misión y valores de yslearn.in",
        "Corporate Responsibility": "Responsabilidad Corporativa",
        "Global Partnerships": "",
      },
      contact: {
        "Contact Success": "¡Sus datos de contacto se enviaron con éxito!",
        "Success Message":
          "Le agradecemos por darnos la oportunidad de servirle, ¡alguien de nuestro equipo se pondrá en contacto con usted en las próximas 48 horas!",
        "Covid Message":
          "Debido a las restricciones de COVID-19, nuestro equipo actualmente está trabajando de forma remota. Complete el formulario para solicitar una devolución de llamada y alguien se comunicará con usted muy pronto. Gracias!",
        "Request CB": "Solicitar una devolución de llamada",
      },
    },
  },
  pt: {
    translation: {
      nav: {
        one: "Uno",
        Home: "Casa",
        Language: "PT",
        English: "English",
        French: "Français",
        German: "Deutsch",
        Portugese: "Português",
        Spanish: "Español",
        Japanese: "日本語",
        Hindi: "हिंदी",
        Russian: "Русский",

        courses: "Cursos",
      },

      tabs: {
        "Learn a new skill today": "Aprenda uma nova habilidade hoje",
        forLiveCourses: "para cursos online AO ​​VIVO",
        chooseLiveWebinar:
          "Escolha cursos baseados em webinar ao vivo ou cursos baseados em vídeo de autoaprendizagem.",
      },

      sideMenu: {
        dashboard: "Painel",
        courses: "Cursos",
        createCourse: "Criar Curso",
        shopCourses: "Cursos de loja",
        myWishlist: "Minha Lista de Desejos",
        webinars: "Webinars",
        results: "Resultados",
        notes: "Notas",
        forum: "Fórum",
        grades: "Notas",
        achievements: "Conquistas",
        announcements: "Anúncios",
        accounts: "Contas",
      },

      status: {
        courseProgress: "Progresso do Curso",
      },

      pricing: {
        "Most Popular": "Mais Popular",
        "No Risk": "Segurança, escalabilidade e acessibilidade em um pacote",
        "All our plans include": "Todos os nossos planos incluem o seguinte",
        "Best Value": "Melhor valor",
        Monthly: "Por mês",
        Yearly: "Anual",
        Pricing: "Preços",
        "Custom pricing":
          "Kontaktieren Sie unseren Vertrieb noch heute für Ihr individuelles Preisangebot",
        "Book a Demo": "Reserve uma demonstração",
        "per year": "por ano",
        "billed annually": "cobrado anualmente",
        Purchase: "Comprar",

        unlmtCourses: "Cursos e atividades ilimitadas",
        "Web conferencing": "Webconferência",
        "Webinar recording": "Gravação de webinar",
        "File sharing": "Compartilhamento de arquivos",
        "Visual scheduling": "Agendamento visual",
        "Community forum": "Fórum da Comunidade",
        Reporting: "Comunicando",
        "Analytics dashboard": "Painel de análise",
        "Concurrent sessions": "Sessões simultâneas",
        "Secure SSL certification": "Certificação SSL segura",
        "Automated backup & restore": "Backup e restauração automatizados",
        "Customer support": "Suporte ao cliente",
      },

      careers: {
        Careerswsmiklearn: "Carreiras com Edusidade",
        curOppwEdu: "Oportunidades abertas atuais com yslearn.in",
        ExpCareers:
          "Explore oportunidades remotas, flexíveis e emocionantes com o yslearn.in, ajude-nos a co-inventar o cenário LMS para o futuro",
        ExpCurOpp: "Explorar posições abertas",
      },

      "Instructor Benefits": "Benefícios do instrutor",
      "Be an Instructor": "Seja um instrutor",
      Instructor: "Instrutor",
      Total: "Total",
      Items: "Itens",
      Remove: "Remover",
      "Shopping Cart": "Carrinho de compras",
      "Buy Later": "Compre mais tarde",
      "Empty your cart": "Esvazie seu carrinho",
      "Taxes will be added at checkout if applicable":
        "Os impostos serão adicionados no checkout, se aplicável",
      "Secure checkout": "Check-out seguro",
      SubTotal: "Subtotal",
      "Shopping Cart Empty": "O seu carrinho de compras está vazio!",
      "Find Something Interesting":
        "Aqui é onde você pode encontrar algo interessante",
      Hey: "Ei",
      "Add to Wishlist": "Adicionado a lista",
      Reviews: "Avaliações",
      "Course Highlights": "Destaques do curso",
      "Related Courses": "Cursos Relacionados",
      "Course Requirements": "Pré-requisitos do curso",
      "Course Description": "Descrição do Curso",
      "Course FAQs": "Perguntas frequentes do curso",
      "Course Syllabus": "Programa do Curso",
      "Enroll for this course": "Inscreva-se neste curso",
      Includes: "Incluindo",
      "Instructor Profile": "Perfil do instrutor",
      "Rate this Course?": "Avalie este Curso?",
      "Last Updated": "Ultima atualização",
      "Course Content": "Conteúdo do curso",
      Languages: "Língua",
      "Questions for the Instructor?": "Perguntas para o Instrutor?",
      smiklearn: "yslearn.in",
      welcome: "Bem-vindo ao aplicativo de teste de yslearn.in",
      introduction: "Descubra uma nova maneira de aprender com yslearn.in hoje!",
      enterpriseEdition: "Clique aqui para a Enterprise Edition",
      Blog: "Blog",
      Login: "Fazer login",
      Signup: "Inscreva-se",
      Features: "Recursos",
      Pricing: "Preços",
      "Take your passion":
        "Leve sua paixão por ensinar para as salas de aula globais",
      learnBeyondBoundaries:
        "A aprendizagem virtual não conhece fronteiras, nem barreiras. Abrace o mundo do conhecimento.",
      checkoutFeatures: "Confira nossos recursos",
      "Login Intro": "Introdução de login",
      or: "ou",
      "Connect with social media": "Conecte-se com a mídia social:",

      "Teach with yslearn.in": "Ensine com yslearn.in",
      Hello: "Olá, você está procurando aprender algo novo hoje?",
      whoIsUsing: "Quem está usando o yslearn.in?",
      featuredOn: "Destaque em",

      "About Us": "Sobre nós",

      "Expert Instructors": "Instrutores Especialistas",
      "Expert Instructors Description":
        "Aprenda com profissionais qualificados e experientes da indústria",
      "Adaptive Learning": "Aprendizagem Adaptativa",
      "Adaptive Learning Description":
        "Aprendizagem individualizada ou webinars ao vivo para cada estilo de aprendizagem",
      "Convinient & Safe": "Conviniente e seguro",
      "Convinient & Safe Description":
        "Por que viajar quando você pode aprender com o conforto e a segurança de sua casa?",
      "Live & Interactive": "Ao vivo e interativo",
      "Live & Interactive Description":
        "Interaja com seus professores em nossos webinars interativos ao vivo",

      "Connect with us": "Conecte-se conosco",
      "Coming Soon": "Em breve",
      "About yslearn.in": "Sobre yslearn.in",
      "yslearn.in Helpdesk": "yslearn.in Helpdesk",
      FAQs: "Perguntas Frequentes",
      "yslearn.in Community": "Comunidade de yslearn.in",
      "Webinars & Events": "Webinars e eventos",
      "News & Press": "Notícias e Imprensa",
      "Cookie Policy": "Política de Cookies",
      "yslearn.in Blog": "yslearn.in Blog",
      "All Categories": "Todas as categorias",
      "Checkout all": "Ver todos",
      courses: "cursos",
      "All Courses": "Todos os cursos",
      "For Post Secondary": "Para pós-secundário",
      "For Corporate Training": "Para treinamento corporativo",
      Careers: "Carreiras",

      "Accessibility Statement": "Declaração de acessibilidade",
      AccHomeDesc:
        "A edusidade fornece acesso à educação além das fronteiras e sem barreiras. Nossas ferramentas para alunos e instrutores são compatíveis com ADA (Americans with Disabilities Act) e AODA (Accessibility for Ontarians with Disabilities Act).",

      events: "Eventos",
      learnMore: "Saber mais",
      sitemap: "Mapa do site",
      "Help and Support": "Ajuda e suporte",
      terms: "Termos",
      "Privacy Policy": "Política de Privacidade",
      "Create Account": "Criar uma conta",

      firstName: "Primeiro nome",
      fullName: "Nome completo",
      lastName: "Último nome",
      email: "o email",
      username: "Nome do usuário",
      phoneNo: "Número de telefone",
      password: "Senha",
      confPassword: "Confirme a Senha",
      continue: "Prosseguir",
      forgotPassword: "Esqueceu sua senha?",
      letsgStr: "Vamos começar",
      connLearEdu:
        "Conectando alunos, educadores e pais de todo o mundo em uma plataforma comum inclusiva e verdadeiramente multilíngue.",
      alreadyRegistered: "Já registrado?",
      wannaReg: "Quero me cadastrar como:",
      notRegistered: "Não registrado ainda?",
      stNameNum: "Número e nome da rua",
      unitNum: "Número de unidade",
      city: "Cidade",
      state: "Província/Estado",
      postalZipCode: "CEP/Código Postal",
      country: "País",
      back: "Voltar",
      comRegistration: "Registro completo",

      cookieStmt:
        "yslearn.in.com usa cookies para gerenciar e melhorar a experiência do usuário em visitas repetidas ao site, lembrando-se de suas escolhas anteriores. Não vendemos, trocamos ou usamos seus dados para fins publicitários. Se você concordar em usar nossos cookies, aceite e continue a usar nosso site. Para obter mais informações, consulte nosso",
      acceptContinue: "Aceitar e continuar",

      getMoreInfo: "Consiga mais informação",

      "Preview Course": "Curso de Antevisão",
      "Buy Course": "Curso de Compra",
      "Testimonials Title":
        "Nossos clientes confiam na rica plataforma da yslearn.in para ajudá-los a oferecer experiências excepcionais e além",

      thankYou: "Obrigada!",

      home: "casa",
      "Contact Us": "Contate-Nos",
      Enterprise: "Para Negócios",
      faqs: "Perguntas Frequentes",
      faqdesc: "Tudo yslearn.in para Instrutores e Alunos",
      "For Enterprise":
        "Soluções de gerenciamento de aprendizagem em nuvem de nível empresarial desenvolvidas com segurança, escalabilidade e segurança em mente!",
      "Blog Intro": "Explore artigos escritos por especialistas",
      Search: "Pesquisa",
      Language: "PL",
      numResults: "There are <1>{{count}}</1> results.",
      moreInfo: "Mais informações",
      addToCart: "Adicionar ao carrinho",
      goToCart: "Ir para o carrinho",
      Keyword: "Palavra Chave",
      Go: "Go",
      Section: "Section",
      "Purchased Course": "Curso comprado",
      features: {
        Dashboard: "Painel",
        "For Learners": "Para Alunos",
        "For Enterprise": "Para Empresas",
        "Webinar Features": "Características del seminario web",
        "Built for Enterprise": "Creado para empresas",
        "White Label Solutions": "Soluciones de marca blanca",
        "yslearn.in System": "Sistema yslearn.in",
      },
      teacherIntro: {
        IntroTitle: "Torne-se um instrutor com yslearn.in",
        IntroDesc1:
          "Seus alunos agradecem pelo seu trabalho? Você está sempre descobrindo novas maneiras de expressar conceitos difíceis? Você planeja atividades que aplicam o conhecimento para inovar e inspirar? Você conhece a satisfação de ajudar os alunos a alcançarem seus sonhos?",
        IntroDesc2:
          "A yslearn.in trabalha com os melhores instrutores online do mundo. Você pode ser um deles.",
        IntroDesc3:
          "Crie um perfil! Sim, fazemos muitas perguntas para garantir que você esteja bem qualificado, consciente e seguro. Mostre-nos seus diplomas, seu portfólio e os relacionamentos que você construiu por meio de uma reputação limpa nas mídias sociais.",
        IntroDesc4:
          "Crie um curso usando nossa ferramenta de arrastar e soltar para fazer upload de seus próprios materiais educacionais. Venda seu curso para alunos novos e existentes. Marque-nos em suas postagens de mídia social e compartilharemos o que você tem.",
        IntroDesc5:
          "yslearn.in ajuda você a cultivar curiosidade, inspiração e ambição. É o que os melhores instrutores fazem.",
      },
      about: {
        "yslearn.in Story": "A história da yslearn.in",
        "Explore yslearn.in": "Explore oportunidades profesionales con yslearn.in",
        "Careers yslearn.in": "Carreiras com Edusidade",
        "Strategic Partner": "Nosso Parceiro Estratégico",
        "Leadership and Vision": "Liderança e Visão",
        "yslearn.in Leadership": "Liderança e Visão",
        "Values and Mission": "Valores e Missão",
        "Corporate Responsibility": "Responsabilidade corporativa",
        "Global Partnerships": "Nossas Parcerias Globais",
      },
      contact: {
        "Contact Success": "Seus dados de contato foram enviados com sucesso!",
        "Success Message":
          "Agradecemos por nos dar a oportunidade de atendê-lo, alguém de nossa equipe entrará em contato com você nas próximas 48 horas!",
        "Covid Message":
          "Devido às restrições do COVID-19, nossa equipe está trabalhando remotamente. Por favor, preencha o formulário para solicitar um retorno de chamada e alguém entrará em contato com você em breve. Obrigada!",
        "Request CB": "Solicitar um retorno de chamada",
      },
    },
  },
  jp: {
    translation: {
      nav: {
        one: "Uno",
        Language: "JP",
        English: "English",
        French: "Français",
        German: "Deutsch",
        Portugese: "Português",
        Spanish: "Español",
        Japanese: "日本語",
        Hindi: "हिंदी",
        Russian: "Русский",

        courses: "コース",
      },

      tabs: {
        "Learn a new skill today": "今日新しいスキルを学ぶ",
        forLiveCourses: "ライブオンラインコースの場合",
        chooseLiveWebinar:
          "ライブウェビナーベースのコースまたは自習用ビデオベースのコースを選択してください。",
      },

      sideMenu: {
        dashboard: "ダッシュボード",
        courses: "コース",
        createCourse: "コースを作成する",
        shopCourses: "ショップコース",
        myWishlist: "私のウィッシュリスト",
        webinars: "ウェビナー",
        results: "結果",
        notes: "ノート",
        forum: "フォーラム",
        grades: "成績",
        achievements: "実績",
        announcements: "お知らせ",
        accounts: "アカウント",
      },

      status: {
        courseProgress: "コースの進捗状況",
      },

      pricing: {
        "Most Popular": "最も人気のある",
        "No Risk":
          "1つのパッケージでのセキュリティ、スケーラビリティ、および手頃な価格",
        "All our plans include": "すべての計画には以下が含まれます",
        "Best Value": "お買い得",
        Monthly: "毎月",
        Yearly: "毎年",
        Pricing: "価格設定",
        "Custom pricing":
          "カスタム価格の見積もりについては、今日のセールスにお問い合わせください",
        "Book a Demo": "デモを予約する",
        "per year": "1年当たり",
        "billed annually": "毎年請求",
        Purchase: "購入",

        unlmtCourses: "無制限のコースとアクティビティ",
        "Web conferencing": "Web会議",
        "Webinar recording": "ウェビナーの記録",
        "File sharing": "ファイル共有",
        "Visual scheduling": "ビジュアルスケジューリング",
        "Community forum": "コミュニティフォーラム",
        Reporting: "報告",
        "Analytics dashboard": "分析ダッシュボード",
        "Concurrent sessions": "同時セッション",
        "Secure SSL certification": "安全なSSL認証",
        "Automated backup & restore": "自動バックアップと復元",
        "Customer support": "顧客サポート",
      },

      careers: {
        Careerswsmiklearn: "yslearn.in のキャリア",
        curOppwEdu: "yslearn.in による現在のオープンな機会",
        ExpCareers:
          "yslearn.inを使用して、リモートで柔軟でエキサイティングな機会を探り、将来のLMSランドスケープを共同で発明するのを手伝ってください",
        ExpCurOpp: "オープンポジションを探索する",
      },

      "Instructor Benefits": "インストラクターのメリット",
      "Be an Instructor": "インストラクターになる",
      Instructor: "インストラクター",
      Total: "合計",
      Items: "アイテム",
      Remove: "削除する",
      "Shopping Cart": "ショッピングカート",
      "Buy Later": "後で購入",
      "Empty your cart": "カートを空にする",
      "Taxes will be added at checkout if applicable":
        "該当する場合、チェックアウト時に税金が追加されます",
      "Secure checkout": "安全なチェックアウト",
      SubTotal: "小計",
      "Shopping Cart Empty": "ショッピングカートは現在空です！",
      "Find Something Interesting":
        "ここで何か面白いものを見つけることができます",
      Hey: "おい",
      "Add to Wishlist": "リストに追加する",
      Reviews: "レビュー",
      "Course Highlights": "コースのハイライト",
      "Related Courses": "関連コース",
      "Course Requirements": "コースの前提条件",
      "Course Description": "コースの説明",
      "Course FAQs": "コースのよくある質問",
      "Course Syllabus": "コースシラバス",
      "Enroll for this course": "このコースに登録する",
      Includes: "含む",
      "Instructor Profile": "インストラクタープロフィール",
      "Rate this Course?": "コースを評価しますか？",
      "Last Updated": "最終更新",
      "Course Content": "講座の内容",
      Languages: "言語",
      "Questions for the Instructor?": "インストラクターへの質問は？",
      smiklearn: "yslearn.in",
      welcome: "私のテストアプリケーションへようこそ",
      introduction: "今日、yslearn.inで新しい学習方法を発見してください",
      enterpriseEdition:
        "Enterprise Edition については、ここをクリックしてください",
      Blog: "ブログ",
      Login: "ログイン",
      Signup: "新規登録",
      Features: "特徴",
      Pricing: "価格設定",
      "Take your passion": "グローバルな教室に教えることに情熱を注いでください",
      learnBeyondBoundaries:
        "仮想学習は境界も障壁も知りません。知識の世界を受け入れる。",
      checkoutFeatures: "私たちの機能をチェックしてください",
      "Login Intro": "ログインイントロ",
      or: "また",
      "Connect with social media": "ソーシャルメディアとつながる：",

      "Teach with yslearn.in": "yslearn.inで教える",
      Hello: "こんにちは、今日は何か新しいことを学びたいですか？",
      whoIsUsing: "yslearn.in を使用しているのは誰ですか？",
      featuredOn: "特集",

      "About Us": "私たちに関しては",
      "Create Account": "アカウントを作成する",

      "Expert Instructors": "エキスパートインストラクター",
      "Expert Instructors Description":
        "資格のある経験豊富な業界の専門家から学ぶ",
      "Adaptive Learning": "アダプティブラーニング",
      "Adaptive Learning Description":
        "あらゆる学習スタイルに対応する自習型学習またはライブウェビナー",
      "Convinient & Safe": "便利で安全",
      "Convinient & Safe Description":
        "家の快適さと安全性から学ぶことができるのに、なぜ旅行するのですか？",
      "Live & Interactive": "ライブ＆インタラクティブ",
      "Live & Interactive Description":
        "インタラクティブなライブウェビナーで教師と交流しましょう",

      "Connect with us": "私達と接続",
      "Coming Soon": "近日公開",
      "About yslearn.in": "yslearn.inについて",
      "yslearn.in Helpdesk": "yslearn.in ヘルプデスク",
      FAQs: "よくある質問",
      "yslearn.in Community": "yslearn.inコミュニティ",
      "Webinars & Events": "ウェビナーとイベント",
      "News & Press": "ニュース＆プレス",
      "Cookie Policy": "クッキーポリシー",
      "yslearn.in Blog": "yslearn.in ブログ",
      "All Categories": "すべてのカテゴリ",
      "Checkout all": "すべてを見る",
      courses: "コース",
      "All Courses": "すべてのコース",
      "For Post Secondary": "中等後の場合",
      "For Corporate Training": "企業研修用",
      Careers: "キャリア",

      events: "イベント",
      faqs: "よくある質問",
      faqdesc: "インストラクターと学習者のためのすべての教育",
      learnMore: "もっと詳しく知る",
      sitemap: "サイトマップ",
      "Help and Support": "ヘルプとサポート",
      terms: "条項",
      "Privacy Policy": "個人情報保護方針",

      firstName: "ファーストネーム",
      fullName: "フルネーム",
      lastName: "苗字",
      email: "Eメール",
      username: "ユーザー名",
      phoneNo: "電話番号",
      password: "パスワード",
      confPassword: "パスワードを認証する",
      continue: "継続する",
      forgotPassword: "パスワードをお忘れですか？",
      letsgStr: "始めましょう",
      connLearEdu:
        "共通の包括的で真に多言語のプラットフォームで、世界中の学習者、教育者、保護者をつなぎます。",
      wannaReg: "として登録したい：",
      alreadyRegistered: "すでに登録？",
      notRegistered: "まだ登録されていませんか？",
      stNameNum: "番地と名前",
      unitNum: "ユニット番号",
      city: "市",
      state: "州/州",
      postalZipCode: "郵便番号/郵便番号",
      country: "国",
      back: "戻る",
      comRegistration: "完全な登録",

      cookieStmt:
        "yslearn.in.comは、Cookieを使用して、過去の選択を記憶することにより、サイトへの繰り返しアクセス時のユーザーエクスペリエンスを管理および改善します。当社は、広告目的でお客様のデータを販売、取引、または使用することはありません。当社のCookieの使用に同意する場合は、当社のサイトを受け入れて引き続き使用してください。詳細については、当社を参照してください",
      acceptContinue: "受け入れて続行",

      getMoreInfo: "にとって",
      thankYou: "ありがとう！",

      "Accessibility Statement": "アクセシビリティステートメント",
      AccHomeDesc:
        "yslearn.in は、境界を越えて、障壁なしで教育へのアクセスを提供します。学習者とインストラクターの両方のためのツールは、ADA（障害を持つアメリカ人法）とAODA（障害を持つアメリカ人法のアクセシビリティ）に準拠しています。",

      "Preview Course": "プレビューコース",
      "Buy Course": "コースを購入する",
      "Testimonials Title":
        "お客様は、yslearn.inの豊富なプラットフォームを信頼して、卓越したエクスペリエンスを提供します。",

      home: "ホーム",
      "Contact Us": "お問い合わせ",
      Enterprise: "仕事のために",
      "For Enterprise":
        "安全性、スケーラビリティ、セキュリティを念頭に置いて構築されたエンタープライズグレードのクラウド学習管理ソリューション！",
      "Blog Intro": "専門家によって書かれた記事を探す",
      numResults: "ここに <1>{{count}}</1> の結果があります",
      Home: "ホーム",
      Search: "探す",
      Language: "JP",
      moreInfo: "より詳しい情報",
      addToCart: "カートに追加",
      goToCart: "カートに移動",
      Keyword: "キーワード",
      Go: "Aller",
      Section: "Section",
      "Purchased Course": "購入したコース",
      features: {
        Dashboard: "ダッシュボード",
        "For Learners": "学習者向け",
        "For Enterprise": "エンタープライズ向け",
        "Webinar Features": "ウェビナーの機能",
        "Built for Enterprise": "エンタープライズ向けに構築",
        "White Label Solutions": "ホワイトラベルソリューション",
        "yslearn.in System": "yslearn.inシステム",
      },
      teacherIntro: {
        IntroTitle: "yslearn.inでインストラクターになる",
        IntroDesc1:
          "あなたの学習者はあなたの仕事に感謝していますか？難しいコンセプトを表現する新しい方法を常に発見していますか？知識を応用して革新と刺激を与える活動を計画していますか？生徒が夢を実現するのを手伝うことの満足感を知っていますか？",
        IntroDesc2:
          "yslearn.inは、世界最高のオンラインインストラクターと協力しています。あなたもその一人かもしれません。",
        IntroDesc3:
          "プロファイルを作成してください！はい、私たちはあなたが十分な資格を持ち、誠実で安全であることを確認するために多くの質問をします。あなたの学位、ポートフォリオ、そしてクリーンなソーシャルメディアの評判を通じて築き上げてきた関係を見せてください。",
        IntroDesc4:
          "ドラッグアンドドロップツールを使用してコースを作成し、独自の教材をアップロードします。新規および既存の学習者にコースを販売します。あなたのソーシャルメディアの投稿で私たちにタグを付けてください。私たちはあなたが持っているものを共有します。",
        IntroDesc5:
          "yslearn.inは、好奇心、インスピレーション、野心を育むのに役立ちます。それは最高のインストラクターが行うことです。",
      },
      about: {
        "yslearn.in Story": "yslearn.in 話",
        "Explore yslearn.in": "yslearn.inでキャリアの機会を探る",
        "Careers yslearn.in": "yslearn.in のキャリア",
        "Strategic Partner": "私たちの戦略的パートナー",
        "Leadership and Vision": "",
        "yslearn.in Leadership": "リーダーシップとビジョン",
        "Values and Mission": "yslearn.in の使命と価値観",
        "Corporate Responsibility": "企業責任",
        "Global Partnerships": "",
      },
      contact: {
        "Contact Success": "連絡先の詳細が正常に送信されました。",
        "Success Message":
          "私たちにあなたに仕える機会を与えてくれてありがとう、私たちのチームの誰かが次の48時間以内にあなたと連絡を取ります！",
        "Covid Message":
          "COVID-19の制限により、私たちのチームは現在リモートで作業しています。フォームに記入してコールバックをリクエストしてください。すぐに誰かから返信があります。ありがとう！",
        "Request CB": "コールバックをリクエストする",
      },
    },
  },
  hi: {
    translation: {
      nav: {
        one: "Uno",
        Home: "घर",
        Language: "HI",
        English: "English",
        French: "French",
        German: "German",

        courses: "पाठ्यक्रम",
      },

      tabs: {
        "Learn a new skill today": "आज एक नया कौशल सीखें",
        forLiveCourses: "लाइव ऑनलाइन पाठ्यक्रम",
        chooseLiveWebinar:
          "लाइव वेबिनार-आधारित पाठ्यक्रम या स्व-अध्ययन वीडियो-आधारित पाठ्यक्रम चुनें।",
      },

      pricing: {
        "Most Popular": "सबसे लोकप्रिय",
        "No Risk": "एक पैकेज में सुरक्षा, मापनीयता और सामर्थ्य",
        "Best Value": "सबसे बेहतर मूल्य",
        Monthly: "महीने के",
        Yearly: "सालाना",
        Pricing: "मूल्य निर्धारण",
        "Custom pricing":
          "अपने कस्टम मूल्य निर्धारण उद्धरण के लिए आज ही हमारी सेल्स टीम से संपर्क करें",
        "Book a Demo": "डेमो बुक करें",
        "per year": "प्रति वर्ष",
        "billed annually": "सालाना बिल किया",
        Purchase: "खरीद",
      },

      status: {
        courseProgress: "पाठ्यक्रम प्रगति",
      },

      careers: {
        Careerswsmiklearn: "एजुसिटी के साथ करियर",
        curOppwEdu: "एजुसिटी के साथ वर्तमान खुले अवसर",
        ExpCareers:
          "yslearn.in (एजुसिटी) के साथ दूरस्थ, लचीले और रोमांचक अवसरों का अन्वेषण करें, भविष्य के लिए LMS परिदृश्य का सह-आविष्कार करने में हमारी सहायता करें",
        ExpCurOpp: "खुली स्थितियों का अन्वेषण करें",
      },

      "Instructor Benefits": "प्रशिक्षक लाभ",
      "Be an Instructor": "प्रशिक्षक बनें",
      Instructor: "प्रशिक्षक",
      Total: "कुल",
      Items: "आइटम",
      Remove: "निकालें",
      "Shopping Cart": "शॉपिंग कार्ट",
      "Buy Later": "बाद में खरीदना",
      "Empty your cart": "अपना कार्ट खाली करें",
      "Taxes will be added at checkout if applicable":
        "यदि लागू हो तो चेकआउट के समय कर जोड़े जाएंगे",
      "Secure checkout": "सुरक्षित चेकआउट",
      SubTotal: "उप-जॉड़",
      "Shopping Cart Empty": "आपका शॉपिंग कार्ट खाली है!",
      "Find Something Interesting": "यहां आपको कुछ दिलचस्प मिल सकता है",
      Hey: "नमस्ते",
      "Add to Wishlist": "सूची में शामिल करें",
      Reviews: "रिव्यू",
      "Course Highlights": "पाठ्यक्रम की विशेषताएं",
      "Related Courses": "संबंधित कोर्स",
      "Course Requirements": "पाठ्यक्रम पूर्वापेक्षाएँ",
      "Course Description": "पाठ्यक्रम विवरण",
      "Course FAQs": "पाठ्यक्रम अक्सर पूछे जाने वाले प्रश्न",
      "Course Syllabus": "पाठ्यक्रम",
      Includes: "शामिल",
      "Instructor Profile": "प्रशिक्षक प्रोफाइल",
      "Enroll for this course": "इस कोर्स के लिए नामांकन करें",
      "Rate this Course?": "इस कोर्स को रेट करें?",
      "Last Updated": "आखरी अपडेट",
      "Course Content": "पाठ्यक्रम",
      Languages: "भाषाएं",
      "Questions for the Instructor?": "प्रशिक्षक के लिए प्रश्न?",
      smiklearn: "yslearn.in",
      welcome: "एडूसिटी के परीक्षण आवेदन में आपका स्वागत है",
      introduction: "आज एडुसिटी के साथ सीखने का एक नया तरीका खोजें!",
      enterpriseEdition: "एंटरप्राइज एडिशन के लिए यहां क्लिक करें",
      Blog: "ब्लॉग",
      Login: "लॉग इन करें",
      Signup: "साइन अप करें",
      Features: "विशेषताएं",
      Pricing: "मूल्य निर्धारण",
      "Take your passion": "पढ़ाने के अपने जुनून को वैश्विक कक्षाओं मे ले चलें",
      learnBeyondBoundaries:
        "अंतरराष्ट्रीय सीमाओं और भाषा बाधाओं से परे सीखना - इंटरैक्टिव और लाइव सीखने की एक नई दुनिया में",
      checkoutFeatures: "हमारी विशेषताएं",
      "Login Intro": "लॉगिन इंट्रो",
      or: "या",
      "Connect with social media": "सोशल मीडिया से जुड़ें:",

      "Teach with yslearn.in": "हमारे साथ शिक्षक बनो",
      Hello: "नमस्कार, क्या आप आज कुछ नया सीखना चाह रहे हैं?",
      whoIsUsing: "एडूसिटी का उपयोग कौन कर रहा है?",
      featuredOn: "समाचार में",

      "About Us": "कुछ हमारे बारे में",

      "Expert Instructors": "विशेषज्ञ प्रशिक्षक",
      "Expert Instructors Description":
        "योग्य और अनुभवी उद्योग पेशेवरों से सीखें",
      "Adaptive Learning": "अनुकूल शिक्षा",
      "Adaptive Learning Description":
        "हर सीखने की शैली के लिए स्व-पुस्तक सीखना या लाइव वेबिनार",
      "Convinient & Safe": "संवाहक और सुरक्षित",
      "Convinient & Safe Description":
        "जब आप अपने घर के आराम और सुरक्षा से सीख सकते हैं तो यात्रा क्यों करें?",
      "Live & Interactive": "लाइव और इंटरएक्टिव",
      "Live & Interactive Description":
        "हमारे लाइव इंटरैक्टिव वेबिनार में अपने शिक्षकों के साथ व्यस्त रहें",

      "Connect with us": "हमसे जुडे",
      "Coming Soon": "जल्द आ रहा है",
      "About yslearn.in": "एडसिटी के बारे में",
      "yslearn.in Helpdesk": "एजुसिटी हेल्पडेस्क",
      FAQs: "पूछे जाने वाले प्रश्न",
      "yslearn.in Community": "एजुसिटी कम्युनिटी",
      "Webinars & Events": "वेबिनार और कार्यक्रम",
      "News & Press": "समाचार और प्रेस",
      "Cookie Policy": "कूकी नीति",
      "yslearn.in Blog": "yslearn.in ब्लॉग",
      "All Categories": "सब वर्ग",
      "Checkout all": "सभी",
      courses: "पाठ्यक्रम",
      "All Courses": "सभी पाठ्यक्रम",
      "For Post Secondary": "उत्तर-माध्यमिक के लिए",
      "For Corporate Training": "कॉर्पोरेट प्रशिक्षण के लिए",
      Careers: "नौकरियां",

      events: "आयोजन",
      learnMore: "अधिक जानकारी",
      sitemap: "साइटमैप",
      "Help and Support": "सहायता और सहयोग",
      terms: "कानूनी शर्तें",
      "Privacy Policy": "गोपनीयता नीति",

      faqs: "पूछे जाने वाले प्रश्न",
      faqdesc: "प्रशिक्षकों और शिक्षार्थियों के लिए सब कुछ yslearn.in",
      "Create Account": "खाता बनाएं",

      firstName: "पहला नाम",
      fullName: "पूरा नाम",
      lastName: "उपनाम",
      email: "ईमेल",
      username: "यूजरनेम",
      phoneNo: "फ़ोन नंबर",
      password: "पासवर्ड",
      confPassword: "पासवर्ड की पुष्टि",
      continue: "आगे बढ़ें",
      forgotPassword: "पासवर्ड भूल गए?",
      letsgStr: "आएँ, शुरुआत करें",
      connLearEdu:
        "एक आम समावेशी और सही मायने में बहुभाषी मंच पर दुनिया भर के शिक्षार्थियों, शिक्षकों और अभिभावकों को जोड़ना।",
      wannaReg: "मैं एक के रूप में पंजीकरण करना चाहता हूं:",
      alreadyRegistered: "पहले से ही पंजीकृत?",
      notRegistered: "पंजीकरण नहीं किया?",
      stNameNum: "सड़क संख्या और नाम",
      unitNum: "खड संख्या",
      city: "शहर",
      state: "प्रांत/राज्य",
      postalZipCode: "ज़िप/पोस्टल कोड",
      country: "देश",
      back: "वापस",
      comRegistration: "पंजीकरण पूर्ण करें",

      cookieStmt:
        "yslearn.in.com uses cookies to manage and improve your user experience on repeat visits to the site by remembering your past choices. We do not sell, trade, or use your data for advertising purposes. If you agree to use our cookies, please accept and continue to use our site. For more information please refer to our",
      acceptContinue: "स्वीकार करें और आगे बढ़ें",

      "Accessibility Statement": "अभिगम्यता विवरण",
      AccHomeDesc:
        "शिक्षा सीमाओं से परे और बाधाओं के बिना शिक्षा तक पहुंच प्रदान करती है। शिक्षार्थियों और प्रशिक्षकों दोनों के लिए हमारे उपकरण एडीए (विकलांगता वाले अमेरिकी अधिनियम) और एओडीए (विकलांगता अधिनियम के साथ ओन्टेरियन के लिए अभिगम्यता) के अनुरूप हैं।",

      getMoreInfo: "अधिक जानकारी के लिये",
      thankYou: "धन्यवाद!",

      "Preview Course": "पूर्वावलोकन पाठ्यक्रम",
      "Buy Course": "कोर्स खरीदें",
      "Testimonials Title":
        "हमारे ग्राहक एडुसिटी के समृद्ध मंच पर भरोसा करते हैं ताकि उन्हें असाधारण अनुभव और उससे भी आगे प्रदान करने में मदद मिल सके",

      home: "घर",
      "Contact Us": "संपर्क करें",
      Enterprise: "उद्यम के लिए",
      "For Enterprise":
        "एंटरप्राइज ग्रेड क्लाउड लर्निंग मैनेजमेंट सॉल्यूशंस को सुरक्षा, मापनीयता और सुरक्षा को ध्यान में रखकर बनाया गया है",
      "Blog Intro": "विशेषज्ञों द्वारा लिखे गए लेखों का अन्वेषण करें",
      Search: "खोज",
      Language: "HI",
      numResults: "<1>{{count}}</1> परिणाम हैं|",
      moreInfo: "अधिक जानकारी",
      addToCart: "कार्ट में डालें",
      goToCart: "शॉपिंग कार्ट पर जाएं",
      Keyword: "कीवर्ड",
      Go: "Go",
      Section: "Section",
      "Purchased Course": "खरीदा पाठ्यक्रम",
      features: {
        Dashboard: "डैशबोर्ड",
        "For Learners": "शिक्षार्थियों के लिए",
        "For Enterprise": "उद्यम के लिए",
        "Webinar Features": "वेबिनार सुविधाएँ",
        "Built for Enterprise": "उद्यम के लिए बनाया गया",
        "White Label Solutions": "व्हाइट लेबल समाधान",
        "yslearn.in System": "शिक्षा प्रणाली",
      },
      pricing: {
        "Pricing Intro":
          "हमारे पैकेज में से किसी एक को चुनें, या कस्टम समाधान और मूल्य निर्धारण पर चर्चा करने के लिए हमसे संपर्क करें",
        "Most Popular": "सबसे लोकप्रिय",
        "No Risk": "एक पैकेज में सुरक्षा, मापनीयता और सामर्थ्य",
        "Best Value": "श्रेष्ठ मूल्य",
        "All our plans include": "हमारी सभी योजनाओं में निम्नलिखित शामिल हैं",
        Monthly: "Monthly",
        Yearly: "Yearly",
        Pricing: "Pricing",
        "Custom pricing":
          "अपने मूल्य निर्धारण उद्धरण के लिए आज ही हमारी बिक्री टीम से संपर्क करें",
        "Book a Demo": "एक डेमो बुक करें",
        "per year": "per year",
        "billed annually": "billed annually",
        Purchase: "Purchase",
        "Contact Sales": "संपर्क करें",

        unlmtCourses: "असीमित पाठ्यक्रम और गतिविधियां",
        "Web conferencing": "Web conferencing",
        "Webinar recording": "वेबिनार रिकॉर्डिंग",
        "File sharing": "फ़ाइल साझा करना",
        "Visual scheduling": "दृश्य शेड्यूलिंग",
        "Community forum": "सामुदायिक फोरम",
        Reporting: "रिपोर्टिंग",
        "Analytics dashboard": "एनालिटिक्स डैशबोर्ड",
        "Concurrent sessions": "समवर्ती सत्र",
        "Secure SSL certification": "सुरक्षित SSL प्रमाणीकरण",
        "Automated backup & restore": "स्वचालित बैकअप और पुनर्स्थापित करें",
        "Customer support": "ग्राहक सहेयता",
      },
      teacherIntro: {
        IntroTitle: "yslearn.in के साथ प्रशिक्षक बनें",
        IntroDesc1:
          "क्या आपके शिक्षार्थी आपके कार्य के लिए आपका धन्यवाद करते हैं? क्या आप हमेशा कठिन अवधारणाओं को व्यक्त करने के नए तरीके खोज रहे हैं? क्या आप ऐसी गतिविधियों की योजना बनाते हैं जो ज्ञान को नया करने और प्रेरित करने के लिए लागू करती हैं? क्या आप जानते हैं कि छात्रों को उनके सपनों को प्राप्त करने में मदद करने की संतुष्टि क्या है?",
        IntroDesc2:
          "yslearn.in दुनिया के सर्वश्रेष्ठ ऑनलाइन प्रशिक्षकों के साथ काम करती है। आप उनमें से एक हो सकते हैं।",
        IntroDesc3:
          "एक प्रोफाइल बनाएं! हां, हम यह सुनिश्चित करने के लिए बहुत सारे प्रश्न पूछते हैं कि आप अच्छी तरह से योग्य, कर्तव्यनिष्ठ और सुरक्षित हैं। हमें अपनी डिग्री, अपना पोर्टफोलियो और एक स्वच्छ सोशल मीडिया प्रतिष्ठा के माध्यम से आपके द्वारा बनाए गए संबंधों को दिखाएं।",
        IntroDesc4:
          "अपनी खुद की शैक्षिक सामग्री अपलोड करने के लिए हमारे ड्रैग एंड ड्रॉप टूल का उपयोग करके एक कोर्स बनाएं। अपने पाठ्यक्रम को नए और मौजूदा शिक्षार्थियों को बेचें। हमें अपने सोशल मीडिया पोस्ट में टैग करें और जो आपके पास है हम उसे साझा करेंगे।",
        IntroDesc5:
          "शिक्षा आपको जिज्ञासा, प्रेरणा और महत्वाकांक्षा पैदा करने में मदद करती है। यह वही है जो सबसे अच्छे प्रशिक्षक करते हैं।",
      },
      about: {
        "yslearn.in Story": "द एडुसिटी स्टोरी",
        "Explore yslearn.in": "yslearn.in के साथ कैरियर के अवसरों का अन्वेषण करें",
        "Careers yslearn.in": "आपका करियर एजुसिटी के साथ",
        "Strategic Partner": "हमारे सामरिक भागीदार",
        "Leadership and Vision": "",
        "yslearn.in Leadership": "नेतृत्व और विजन",
        "Values and Mission": "yslearn.in का मिशन और मूल्य",
        "Corporate Responsibility": "कॉर्पोरेट जिम्मेदारी",
        "Global Partnerships": "हमारी वैश्विक भागीदारी",
      },
      contact: {
        "Contact Success": "आपका संपर्क विवरण सफलतापूर्वक भेज दिया गया है!",
        "Success Message":
          "हमें आपकी सेवा करने का अवसर देने के लिए हम आपकी सराहना करते हैं, हमारी टीम का कोई व्यक्ति अगले 48 घंटों में आपके संपर्क में रहेगा!",
        "Covid Message":
          "COVID-19 प्रतिबंधों के कारण, हमारी टीम वर्तमान में दूर से काम कर रही है। कृपया कॉलबैक का अनुरोध करने के लिए फ़ॉर्म भरें और कोई बहुत जल्द आपसे संपर्क करेगा। धन्यवाद!",
        "Request CB": "कॉल बैक का अनुरोध करें",
      },
    },
  },
  ru: {
    translation: {
      nav: {
        one: "Uno",
        Home: "Главная",
        Language: "RU",
        English: "English",
        French: "French",
        German: "German",

        courses: "Курсы",
      },

      tabs: {
        "Learn a new skill today": "Изучите новый навык сегодня",
        forLiveCourses: "для онлайн-курсов LIVE",
        chooseLiveWebinar:
          "Выберите онлайн-курсы на основе вебинаров или видео-курсы для самостоятельного изучения.",
      },

      pricing: {
        "Most Popular": "Самый популярный",
        "No Risk":
          "Безопасность, масштабируемость и доступность в одном пакете",
        "Best Value": "Лучшее значение",
        Monthly: "Ежемесячно",
        Yearly: "Ежегодно",
        Pricing: "Ценообразование",
        "Custom pricing":
          "Свяжитесь с нашим отделом продаж сегодня, чтобы получить индивидуальное ценовое предложение",
        "Book a Demo": "ЗАБРОНИРОВАТЬ ДЕМО",
        "per year": "в год",
        "billed annually": "счет ежегодно",
        Purchase: "Покупка",
      },

      status: {
        courseProgress: "Прогресс курса",
      },

      careers: {
        Careerswsmiklearn: "Карьера в yslearn.in",
        curOppwEdu: "Текущие открытые возможности с yslearn.in",
        ExpCareers:
          "Исследуйте удаленные, гибкие и захватывающие возможности с yslearn.in, помогите нам совместно разработать ландшафт LMS для будущего",
        ExpCurOpp: "Исследуйте открытые позиции",
      },

      "Instructor Benefits": "Преимущества для инструктора",
      "Be an Instructor": "Быть инструктором",
      Instructor: "Инструктор",
      Total: "Всего",
      Items: "Предметы",
      Remove: "Удалять",
      "Shopping Cart": "Корзина",
      "Buy Later": "Купить позже",
      "Empty your cart": "Очистить корзину",
      "Taxes will be added at checkout if applicable":
        "Налоги будут добавлены при оформлении заказа, если применимо",
      "Secure checkout": "Безопасная оплата",
      SubTotal: "Промежуточный итог",
      "Shopping Cart Empty": "Ваша корзина пуста!",
      "Find Something Interesting": "Здесь вы можете найти что-то интересное",
      Hey: "Привет",
      "Add to Wishlist": "Добавить в список",
      Reviews: "Отзывы",
      "Course Highlights": "Основные моменты курса",
      "Related Courses": "Связанные курсы",
      "Course Requirements": "Предпосылки курса",
      "Course Description": "Описание курса",
      "Course FAQs": "Часто задаваемые вопросы о курсе",
      "Course Syllabus": "Учебная программа",
      Includes: "В том числе",
      "Enroll for this course": "Записаться на этот курс",
      "Instructor Profile": "Профиль инструктора",
      "Rate this Course?": "Оценить этот курс?",
      "Last Updated": "Последнее обновление",
      "Course Content": "Содержание курса",
      Languages: "Языки",
      "Questions for the Instructor?": "Вопросы к инструктору?",
      smiklearn: "yslearn.in",
      welcome: "Добро пожаловать в тестовое приложение Фалгун Пандья",
      introduction:
        "Откройте для себя новый способ обучения с yslearn.in уже сегодня!",
      enterpriseEdition: "Нажмите здесь, чтобы получить Enterprise Edition",
      Blog: "Блог",
      Login: "Войти",
      Signup: "Регистрация",
      Features: "Функции",
      Pricing: "Ценообразование",
      "Take your passion":
        "Перенесите свою страсть к преподаванию в учебные классы по всему миру",
      learnBeyondBoundaries:
        "Обучение за пределами международных границ и языковых барьеров - в новом мире интерактивного и живого обучения",
      checkoutFeatures: "Ознакомьтесь с нашими функциями",
      "Login Intro": "Войти Введение",
      or: "или",
      "Connect with social media": "Подключитесь к социальным сетям:",

      "Teach with yslearn.in": "Обучайте с yslearn.in",
      Hello: "Здравствуйте, хотите узнать что-то новое сегодня?",
      whoIsUsing: "Кто использует yslearn.in?",
      featuredOn: "Показано на",
      "Coming Soon": "Скоро",

      "Accessibility Statement": "Заявление о доступности",
      AccHomeDesc:
        "yslearn.in предоставляет доступ к образованию без границ и без барьеров. Наши инструменты как для учащихся, так и для преподавателей соответствуют требованиям ADA (Закон об американцах-инвалидах) и AODA (Закон о доступности для жителей Онтарио с ограниченными возможностями).",

      "About Us": "О нас",

      "Expert Instructors": "Опытные инструкторы",
      "Expert Instructors Description":
        "Учитесь у квалифицированных и опытных профессионалов отрасли",
      "Adaptive Learning": "Адаптивное обучение",
      "Adaptive Learning Description":
        "Самостоятельное обучение или живые вебинары для любого стиля обучения",
      "Convinient & Safe": "Удобно и безопасно",
      "Convinient & Safe Description":
        "Зачем путешествовать, если вы можете учиться, не выходя из дома?",
      "Live & Interactive": "Живой и интерактивный",
      "Live & Interactive Description":
        "Общайтесь со своими учителями на наших интерактивных вебинарах в реальном времени",

      "Connect with us": "связаться с нами",
      "About yslearn.in": "О yslearn.in",
      "yslearn.in Helpdesk": "Служба поддержки Эдусити",
      FAQs: "Часто задаваемые вопросы",
      "yslearn.in Community": "Сообщество Эдусити",
      "Webinars & Events": "Вебинары и мероприятия",
      "News & Press": "Новости и пресса",
      "Cookie Policy": "Cookie-файлы Политика",
      "yslearn.in Blog": "yslearn.in Блог",
      "All Categories": "все категории",
      "Checkout all": "Увидеть все",
      courses: "курсы",
      "All Courses": "Все курсы",
      "For Post Secondary": "Для послесреднего",
      "For Corporate Training": "Для корпоративного обучения",
      Careers: "Вакансии",

      events: "События",
      learnMore: "Информация",
      sitemap: "Карта сайта",
      "Help and Support": "Служба поддержки",
      terms: "сроки",
      "Privacy Policy": "политика конфиденциальности",

      firstName: "Имя",
      fullName: "Полное имя",
      lastName: "Фамилия",
      email: "Эл. адрес",
      username: "Имя пользователя",
      phoneNo: "Номер телефона",
      password: "Пароль",
      confPassword: "Подтвердите пароль",
      continue: "Продолжать",
      forgotPassword: "Забыл пароль?",
      letsgStr: "Давайте начнем",
      connLearEdu:
        "Объединение учащихся, педагогов и родителей со всего мира на общей инклюзивной и действительно многоязычной платформе.",
      wannaReg: "Я хочу зарегистрироваться как:",
      alreadyRegistered: "Уже зарегистрирован?",
      notRegistered: "Еще не зарегистрированы?",
      stNameNum: "Номер улицы и имя",
      unitNum: "Номер объекта",
      city: "Город",
      state: "Провинция / Штат",
      postalZipCode: "Почтовый индекс",
      country: "Страна",
      back: "Назад",
      comRegistration: "Завершите регистрацию",
      faqs: "Часто задаваемые вопросы",
      faqdesc: "Все, что yslearn.in для инструкторов и учащихся",

      cookieStmt:
        "yslearn.in.com использует файлы cookie для управления и улучшения вашего пользовательского опыта при повторных посещениях сайта, запоминая ваши прошлые выборы. Мы не продаем, не обмениваем и не используем ваши данные в рекламных целях. Если вы согласны использовать наши файлы cookie, примите и продолжайте использовать наш сайт. Для получения дополнительной информации, пожалуйста, обратитесь к нашему",
      acceptContinue: "Принять и продолжить",

      getMoreInfo: "Получить больше информации",

      "Preview Course": "Курс покупки",
      "Buy Course": "Купить курс",
      "Testimonials Title":
        "Наши клиенты доверяют богатой платформе yslearn.in, которая помогает им предоставлять исключительный опыт и не только",

      thankYou: "Спасибо!",
      "Create Account": "Создать аккаунт",

      home: "Главная",
      "Contact Us": "Связаться с нами",
      Enterprise: "Для бизнеса",
      "For Enterprise":
        "Решения для управления облачным обучением корпоративного уровня, созданные с учетом требований безопасности, масштабируемости и безопасности!",
      "Blog Intro": "Изучите статьи, написанные экспертами",
      Search: "Поиск",
      Language: "RU",
      numResults: "Есть <1>{{count}}</1> результатов.",
      moreInfo: "Больше информации",
      addToCart: "Добавить в корзину",
      goToCart: "Перейти в корзину",
      Keyword: "Ключевое слово",
      Go: "Идти",
      Section: "Раздел",
      "Purchased Course": "Приобретенный курс",
      features: {
        Dashboard: "Панель приборов",
        "For Learners": "Для учащихся",
        "For Enterprise": "Для предприятия",
        "Webinar Features": "Возможности вебинара",
        "Built for Enterprise": "Создан для предприятия",
        "White Label Solutions": "Решения White Label",
        "yslearn.in System": "Система yslearn.in",
      },
      teacherIntro: {
        IntroTitle: "Станьте инструктором с yslearn.in",
        IntroDesc1:
          "Ученики благодарят вас за вашу работу? Вы всегда находите новые способы выражения сложных понятий? Планируете ли вы мероприятия, в которых применяются знания для инноваций и вдохновения? Вам знакомо удовлетворение от помощи ученикам в осуществлении их мечты?",
        IntroDesc2:
          "yslearn.in работает с лучшими онлайн-инструкторами в мире. Вы можете быть одним из них.",
        IntroDesc3:
          "Создайте профиль! Да, мы задаем много вопросов, чтобы убедиться, что вы квалифицированы, добросовестны и находитесь в безопасности. Покажите нам свои дипломы, портфолио и отношения, которые вы построили благодаря чистой репутации в социальных сетях.",
        IntroDesc4:
          "Создайте курс, используя наш инструмент перетаскивания, чтобы загрузить собственные учебные материалы. Продайте свой курс новым и существующим учащимся. Отмечайте нас в своих постах в социальных сетях, и мы поделимся тем, что у вас есть.",
        IntroDesc5:
          "yslearn.in помогает развивать любознательность, вдохновение и амбиции. Это то, что делают лучшие инструкторы.",
      },
      pricing: {
        "Pricing Intro":
          "Выберите один из наших пакетов или свяжитесь с нами, чтобы обсудить индивидуальное решение и цены",
        "Most Popular": "Самый популярный",
        "No Risk":
          "Безопасность, масштабируемость и доступность в одном пакете",
        "Best Value": "Лучшее соотношение",
        "All our plans include": "Все наши планы включают следующее",
        Monthly: "Monthly",
        Yearly: "Yearly",
        Pricing: "Pricing",
        "Custom pricing":
          "Свяжитесь с нашим отделом продаж сегодня, чтобы получить индивидуальное ценовое предложение.",
        "Book a Demo": "Заказать демонстрацию",
        "per year": "per year",
        "billed annually": "billed annually",
        Purchase: "Purchase",
        "Contact Sales": "Связаться с отделом продаж",

        unlmtCourses: "Неограниченные курсы и мероприятия",
        "Web conferencing": "Веб-конференции",
        "Webinar recording": "Запись вебинара",
        "File sharing": "Обмен файлами",
        "Visual scheduling": "Визуальное планирование",
        "Community forum": "Форум сообщества",
        Reporting: "Составление отчетов",
        "Analytics dashboard": "Панель управления аналитикой",
        "Concurrent sessions": "Параллельные сеансы",
        "Secure SSL certification": "Безопасная SSL-сертификация",
        "Automated backup & restore":
          "Автоматическое резервное копирование и восстановление",
        "Customer support": "Служба поддержки",
      },
      about: {
        "yslearn.in Story": "Наше глобальное партнерство",
        "Explore yslearn.in": "Исследуйте возможности карьерного роста с yslearn.in",
        "Careers yslearn.in": "Карьера в yslearn.in",
        "Strategic Partner": "Наш стратегический партнер",
        "Leadership and Vision": "Leadership and Vision",
        "yslearn.in Leadership": "yslearn.in Leadership",
        "Values and Mission": "Миссия и ценности yslearn.in",
        "Corporate Responsibility": "Ответственность каждого члена корпорации",
        "Global Partnerships": "Наше глобальное партнерство",
      },
      contact: {
        "Contact Success": "Ваши контактные данные успешно отправлены!",
        "Success Message":
          "Мы благодарим вас за предоставленную нам возможность служить вам, кто-то из нашей команды свяжется с вами в течение следующих 48 часов!",
        "Covid Message":
          "В связи с ограничениями COVID-19 наша команда в настоящее время работает удаленно. Пожалуйста, заполните форму, чтобы запросить обратный звонок, и кто-то свяжется с вами в ближайшее время. Спасибо!",
        "Request CB": "Заказать обратный звонок",
      },
    },
  },
};

export { resources };
